"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CColorPicker = exports.default = void 0;

var _chunk76875e = require("./chunk-76875e58.js");

var _ColorPickerInput5631f = require("./ColorPickerInput-5631f400.js");

var _react3 = _interopRequireDefault2(require("react"));

var _chunk8219403d = require("./chunk-8219403d.js");

require("prop-types");

var _chunkEb19ede = require("./chunk-eb19ede6.js");

var _colorutils997790c = require("./colorutils-997790c4.js");

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _styledComponents = _interopRequireDefault2(require("styled-components"));

var _chunkB15f = require("./chunk-b15f6972.js");

var _ColorPickerFields = _interopRequireDefault2(require("./ColorPickerFields.js"));

var _ColorPickerSwatches = _interopRequireDefault2(require("./ColorPickerSwatches.js"));

require("./chunk-6104512b.js");

require("./chunk-cb015231.js");

require("./chunk-f2932d1d.js");

require("./CIconButton.js");

require("classnames");

require("./CButton.js");

require("./layout.js");

require("./chunk-48de8464.js");

require("./chunk-e8276423.js");

function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var alpha = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var calculateChange = exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

    if (direction === 'vertical') {
      var a = void 0;

      if (top < 0) {
        a = 0;
      } else if (top > containerHeight) {
        a = 1;
      } else {
        a = Math.round(top * 100 / containerHeight) / 100;
      }

      if (hsl.a !== a) {
        return {
          h: hsl.h,
          s: hsl.s,
          l: hsl.l,
          a: a,
          source: 'rgb'
        };
      }
    } else {
      var _a = void 0;

      if (left < 0) {
        _a = 0;
      } else if (left > containerWidth) {
        _a = 1;
      } else {
        _a = Math.round(left * 100 / containerWidth) / 100;
      }

      if (initialA !== _a) {
        return {
          h: hsl.h,
          s: hsl.s,
          l: hsl.l,
          a: _a,
          source: 'rgb'
        };
      }
    }

    return null;
  };
});
(0, _chunk76875e.b)(alpha);
var alpha_1 = alpha.calculateChange;
var checkboard = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var checkboardCache = {};

  var render = exports.render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) {
      return null;
    }

    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');

    if (!ctx) {
      return null;
    }

    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
  };

  var get = exports.get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

    if (checkboardCache[key]) {
      return checkboardCache[key];
    }

    var checkboard = render(c1, c2, size, serverCanvas);
    checkboardCache[key] = checkboard;
    return checkboard;
  };
});
(0, _chunk76875e.b)(checkboard);
var checkboard_1 = checkboard.render;
var checkboard_2 = checkboard.get;
var Checkboard_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Checkboard = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var checkboard$$1 = _interopRequireWildcard(checkboard);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Checkboard = exports.Checkboard = function Checkboard(_ref) {
    var white = _ref.white,
        grey = _ref.grey,
        size = _ref.size,
        renderers = _ref.renderers,
        borderRadius = _ref.borderRadius,
        boxShadow = _ref.boxShadow;
    var styles = (0, _reactcss2.default)({
      'default': {
        grid: {
          borderRadius: borderRadius,
          boxShadow: boxShadow,
          absolute: '0px 0px 0px 0px',
          background: 'url(' + checkboard$$1.get(white, grey, size, renderers.canvas) + ') center left'
        }
      }
    });
    return _react2.default.createElement('div', {
      style: styles.grid
    });
  };

  Checkboard.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
  };
  exports.default = Checkboard;
});
(0, _chunk76875e.b)(Checkboard_1);
var Checkboard_2 = Checkboard_1.Checkboard;
var Alpha_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Alpha = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var alpha$$1 = _interopRequireWildcard(alpha);

  var _Checkboard2 = _interopRequireDefault(Checkboard_1);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Alpha = exports.Alpha = function (_ref) {
    _inherits(Alpha, _ref);

    function Alpha() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, Alpha);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
        var change = alpha$$1.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
        change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
      }, _this.handleMouseDown = function (e) {
        _this.handleChange(e);

        window.addEventListener('mousemove', _this.handleChange);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }, _this.handleMouseUp = function () {
        _this.unbindEventListeners();
      }, _this.unbindEventListeners = function () {
        window.removeEventListener('mousemove', _this.handleChange);
        window.removeEventListener('mouseup', _this.handleMouseUp);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Alpha, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unbindEventListeners();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var rgb = this.props.rgb;
        var styles = (0, _reactcss2.default)({
          'default': {
            alpha: {
              absolute: '0px 0px 0px 0px',
              borderRadius: this.props.radius
            },
            checkboard: {
              absolute: '0px 0px 0px 0px',
              overflow: 'hidden',
              borderRadius: this.props.radius
            },
            gradient: {
              absolute: '0px 0px 0px 0px',
              background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
              boxShadow: this.props.shadow,
              borderRadius: this.props.radius
            },
            container: {
              position: 'relative',
              height: '100%',
              margin: '0 3px'
            },
            pointer: {
              position: 'absolute',
              left: rgb.a * 100 + '%'
            },
            slider: {
              width: '4px',
              borderRadius: '1px',
              height: '8px',
              boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
              background: '#fff',
              marginTop: '1px',
              transform: 'translateX(-2px)'
            }
          },
          'vertical': {
            gradient: {
              background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
            },
            pointer: {
              left: 0,
              top: rgb.a * 100 + '%'
            }
          },
          'overwrite': _extends({}, this.props.style)
        }, {
          vertical: this.props.direction === 'vertical',
          overwrite: true
        });
        return _react2.default.createElement('div', {
          style: styles.alpha
        }, _react2.default.createElement('div', {
          style: styles.checkboard
        }, _react2.default.createElement(_Checkboard2.default, {
          renderers: this.props.renderers
        })), _react2.default.createElement('div', {
          style: styles.gradient
        }), _react2.default.createElement('div', {
          style: styles.container,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        }, _react2.default.createElement('div', {
          style: styles.pointer
        }, this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', {
          style: styles.slider
        }))));
      }
    }]);

    return Alpha;
  }(_chunk8219403d.a.PureComponent || _chunk8219403d.a.Component);

  exports.default = Alpha;
});
(0, _chunk76875e.b)(Alpha_1);
var Alpha_2 = Alpha_1.Alpha;
var EditableInput_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.EditableInput = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DEFAULT_ARROW_OFFSET = 1;
  var UP_KEY_CODE = 38;
  var DOWN_KEY_CODE = 40;
  var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];

  var isValidKeyCode = function isValidKeyCode(keyCode) {
    return VALID_KEY_CODES.indexOf(keyCode) > -1;
  };

  var getFormattedPercentage = function getFormattedPercentage(number) {
    return number + '%';
  };

  var getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
  };

  var getIsPercentage = function getIsPercentage(value) {
    return String(value).indexOf('%') > -1;
  };

  var EditableInput = exports.EditableInput = function (_ref) {
    _inherits(EditableInput, _ref);

    function EditableInput(props) {
      _classCallCheck(this, EditableInput);

      var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

      _this.handleBlur = function () {
        if (_this.state.blurValue) {
          _this.setState({
            value: _this.state.blurValue,
            blurValue: null
          });
        }
      };

      _this.handleChange = function (e) {
        _this.setUpdatedValue(e.target.value, e);
      };

      _this.handleKeyDown = function (e) {
        var value = getNumberValue(e.target.value);

        if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
          var offset = _this.getArrowOffset();

          var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

          _this.setUpdatedValue(updatedValue, e);
        }
      };

      _this.handleDrag = function (e) {
        if (_this.props.dragLabel) {
          var newValue = Math.round(_this.props.value + e.movementX);

          if (newValue >= 0 && newValue <= _this.props.dragMax) {
            _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
          }
        }
      };

      _this.handleMouseDown = function (e) {
        if (_this.props.dragLabel) {
          e.preventDefault();

          _this.handleDrag(e);

          window.addEventListener('mousemove', _this.handleDrag);
          window.addEventListener('mouseup', _this.handleMouseUp);
        }
      };

      _this.handleMouseUp = function () {
        _this.unbindEventListeners();
      };

      _this.unbindEventListeners = function () {
        window.removeEventListener('mousemove', _this.handleDrag);
        window.removeEventListener('mouseup', _this.handleMouseUp);
      };

      _this.state = {
        value: String(props.value).toUpperCase(),
        blurValue: String(props.value).toUpperCase()
      };
      return _this;
    }

    _createClass(EditableInput, [{
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps, prevState) {
        if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
          if (this.input === document.activeElement) {
            this.setState({
              blurValue: String(this.props.value).toUpperCase()
            });
          } else {
            this.setState({
              value: String(this.props.value).toUpperCase(),
              blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
            });
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unbindEventListeners();
      }
    }, {
      key: 'getValueObjectWithLabel',
      value: function getValueObjectWithLabel(value) {
        return _defineProperty({}, this.props.label, value);
      }
    }, {
      key: 'getArrowOffset',
      value: function getArrowOffset() {
        return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
      }
    }, {
      key: 'setUpdatedValue',
      value: function setUpdatedValue(value, e) {
        var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
        this.props.onChange && this.props.onChange(onChangeValue, e);
        var isPercentage = getIsPercentage(e.target.value);
        this.setState({
          value: isPercentage ? getFormattedPercentage(value) : value
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var styles = (0, _reactcss2.default)({
          'default': {
            wrap: {
              position: 'relative'
            }
          },
          'user-override': {
            wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
            input: this.props.style && this.props.style.input ? this.props.style.input : {},
            label: this.props.style && this.props.style.label ? this.props.style.label : {}
          },
          'dragLabel-true': {
            label: {
              cursor: 'ew-resize'
            }
          }
        }, {
          'user-override': true
        }, this.props);
        return _react2.default.createElement('div', {
          style: styles.wrap
        }, _react2.default.createElement('input', {
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }), this.props.label && !this.props.hideLabel ? _react2.default.createElement('span', {
          style: styles.label,
          onMouseDown: this.handleMouseDown
        }, this.props.label) : null);
      }
    }]);

    return EditableInput;
  }(_chunk8219403d.a.PureComponent || _chunk8219403d.a.Component);

  exports.default = EditableInput;
});
(0, _chunk76875e.b)(EditableInput_1);
var EditableInput_2 = EditableInput_1.EditableInput;
var hue = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var calculateChange = exports.calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

    if (direction === 'vertical') {
      var h = void 0;

      if (top < 0) {
        h = 359;
      } else if (top > containerHeight) {
        h = 0;
      } else {
        var percent = -(top * 100 / containerHeight) + 100;
        h = 360 * percent / 100;
      }

      if (hsl.h !== h) {
        return {
          h: h,
          s: hsl.s,
          l: hsl.l,
          a: hsl.a,
          source: 'rgb'
        };
      }
    } else {
      var _h = void 0;

      if (left < 0) {
        _h = 0;
      } else if (left > containerWidth) {
        _h = 359;
      } else {
        var _percent = left * 100 / containerWidth;

        _h = 360 * _percent / 100;
      }

      if (hsl.h !== _h) {
        return {
          h: _h,
          s: hsl.s,
          l: hsl.l,
          a: hsl.a,
          source: 'rgb'
        };
      }
    }

    return null;
  };
});
(0, _chunk76875e.b)(hue);
var hue_1 = hue.calculateChange;
var Hue_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Hue = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var hue$$1 = _interopRequireWildcard(hue);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Hue = exports.Hue = function (_ref) {
    _inherits(Hue, _ref);

    function Hue() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, Hue);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
        var change = hue$$1.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
        change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
      }, _this.handleMouseDown = function (e) {
        _this.handleChange(e);

        window.addEventListener('mousemove', _this.handleChange);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }, _this.handleMouseUp = function () {
        _this.unbindEventListeners();
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Hue, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.unbindEventListeners();
      }
    }, {
      key: 'unbindEventListeners',
      value: function unbindEventListeners() {
        window.removeEventListener('mousemove', this.handleChange);
        window.removeEventListener('mouseup', this.handleMouseUp);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props$direction = this.props.direction,
            direction = _props$direction === undefined ? 'horizontal' : _props$direction;
        var styles = (0, _reactcss2.default)({
          'default': {
            hue: {
              absolute: '0px 0px 0px 0px',
              borderRadius: this.props.radius,
              boxShadow: this.props.shadow
            },
            container: {
              padding: '0 2px',
              position: 'relative',
              height: '100%',
              borderRadius: this.props.radius
            },
            pointer: {
              position: 'absolute',
              left: this.props.hsl.h * 100 / 360 + '%'
            },
            slider: {
              marginTop: '1px',
              width: '4px',
              borderRadius: '1px',
              height: '8px',
              boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
              background: '#fff',
              transform: 'translateX(-2px)'
            }
          },
          'vertical': {
            pointer: {
              left: '0px',
              top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
            }
          }
        }, {
          vertical: direction === 'vertical'
        });
        return _react2.default.createElement('div', {
          style: styles.hue
        }, _react2.default.createElement('div', {
          className: 'hue-' + direction,
          style: styles.container,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        }, _react2.default.createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), _react2.default.createElement('div', {
          style: styles.pointer
        }, this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', {
          style: styles.slider
        }))));
      }
    }]);

    return Hue;
  }(_chunk8219403d.a.PureComponent || _chunk8219403d.a.Component);

  exports.default = Hue;
});
(0, _chunk76875e.b)(Hue_1);
var Hue_2 = Hue_1.Hue;

function assignMergeValue(object, key, value) {
  if (value !== undefined && !(0, _ColorPickerInput5631f.c)(object[key], value) || value === undefined && !(key in object)) {
    (0, _ColorPickerInput5631f.b)(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue;

function isArrayLikeObject(value) {
  return (0, _ColorPickerInput5631f.e)(value) && (0, _ColorPickerInput5631f.d)(value);
}

var isArrayLikeObject_1 = isArrayLikeObject;

function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet;

function toPlainObject(value) {
  return (0, _ColorPickerInput5631f.f)(value, (0, _ColorPickerInput5631f.g)(value));
}

var toPlainObject_1 = toPlainObject;

function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);

    return;
  }

  var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = (0, _ColorPickerInput5631f.m)(srcValue),
        isBuff = !isArr && (0, _ColorPickerInput5631f.n)(srcValue),
        isTyped = !isArr && !isBuff && (0, _ColorPickerInput5631f.r)(srcValue);
    newValue = srcValue;

    if (isArr || isBuff || isTyped) {
      if ((0, _ColorPickerInput5631f.m)(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject_1(objValue)) {
        newValue = (0, _ColorPickerInput5631f.j)(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = (0, _ColorPickerInput5631f.h)(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = (0, _ColorPickerInput5631f.i)(srcValue, true);
      } else {
        newValue = [];
      }
    } else if ((0, _ColorPickerInput5631f.q)(srcValue) || (0, _ColorPickerInput5631f.l)(srcValue)) {
      newValue = objValue;

      if ((0, _ColorPickerInput5631f.l)(objValue)) {
        newValue = toPlainObject_1(objValue);
      } else if (!(0, _ColorPickerInput5631f.p)(objValue) || (0, _ColorPickerInput5631f.o)(objValue)) {
        newValue = (0, _ColorPickerInput5631f.k)(srcValue);
      }
    } else {
      isCommon = false;
    }
  }

  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }

  _assignMergeValue(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep;

function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }

  (0, _ColorPickerInput5631f.t)(source, function (srcValue, key) {
    stack || (stack = new _ColorPickerInput5631f.s());

    if ((0, _ColorPickerInput5631f.p)(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    } else {
      var newValue = customizer ? customizer(_safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }

      _assignMergeValue(object, key, newValue);
    }
  }, _ColorPickerInput5631f.g);
}

var _baseMerge = baseMerge;

function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);

    case 1:
      return func.call(thisArg, args[0]);

    case 2:
      return func.call(thisArg, args[0], args[1]);

    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }

  return func.apply(thisArg, args);
}

var _apply = apply;
var nativeMax = Math.max;

function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }

    index = -1;
    var otherArgs = Array(start + 1);

    while (++index < start) {
      otherArgs[index] = args[index];
    }

    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

function constant(value) {
  return function () {
    return value;
  };
}

var constant_1 = constant;
var baseSetToString = !_ColorPickerInput5631f.u ? _ColorPickerInput5631f.v : function (func, string) {
  return (0, _ColorPickerInput5631f.u)(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};
var _baseSetToString = baseSetToString;
var HOT_COUNT = 800,
    HOT_SPAN = 16;
var nativeNow = Date.now;

function shortOut(func) {
  var count = 0,
      lastCalled = 0;
  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;

    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }

    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

function baseRest(func, start) {
  return _setToString(_overRest(func, start, _ColorPickerInput5631f.v), func + '');
}

var _baseRest = baseRest;

function isIterateeCall(value, index, object) {
  if (!(0, _ColorPickerInput5631f.p)(object)) {
    return false;
  }

  var type = _typeof(index);

  if (type == 'number' ? (0, _ColorPickerInput5631f.d)(object) && (0, _ColorPickerInput5631f.w)(index, object.length) : type == 'string' && index in object) {
    return (0, _ColorPickerInput5631f.c)(object[index], value);
  }

  return false;
}

var _isIterateeCall = isIterateeCall;

function createAssigner(assigner) {
  return _baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;
    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }

    object = Object(object);

    while (++index < length) {
      var source = sources[index];

      if (source) {
        assigner(object, source, index, customizer);
      }
    }

    return object;
  });
}

var _createAssigner = createAssigner;

var merge = _createAssigner(function (object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

var merge_1 = merge;
var Raised_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Raised = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _merge2 = _interopRequireDefault(merge_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Raised = exports.Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth,
        radius = _ref.radius,
        background = _ref.background,
        children = _ref.children,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        wrap: {
          position: 'relative',
          display: 'inline-block'
        },
        content: {
          position: 'relative'
        },
        bg: {
          absolute: '0px 0px 0px 0px',
          boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
          borderRadius: radius,
          background: background
        }
      },
      'zDepth-0': {
        bg: {
          boxShadow: 'none'
        }
      },
      'zDepth-1': {
        bg: {
          boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
        }
      },
      'zDepth-2': {
        bg: {
          boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
        }
      },
      'zDepth-3': {
        bg: {
          boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
        }
      },
      'zDepth-4': {
        bg: {
          boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
        }
      },
      'zDepth-5': {
        bg: {
          boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
        }
      },
      'square': {
        bg: {
          borderRadius: '0'
        }
      },
      'circle': {
        bg: {
          borderRadius: '50%'
        }
      }
    }, passedStyles), {
      'zDepth-1': zDepth === 1
    });
    return _react2.default.createElement('div', {
      style: styles.wrap
    }, _react2.default.createElement('div', {
      style: styles.bg
    }), _react2.default.createElement('div', {
      style: styles.content
    }, children));
  };

  Raised.propTypes = {
    background: _propTypes2.default.string,
    zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
    radius: _propTypes2.default.number,
    styles: _propTypes2.default.object
  };
  Raised.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
  };
  exports.default = Raised;
});
(0, _chunk76875e.b)(Raised_1);
var Raised_2 = Raised_1.Raised;

var now = function now() {
  return _ColorPickerInput5631f.x.Date.now();
};

var now_1 = now;
var NAN = 0 / 0;
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;

function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }

  if ((0, _ColorPickerInput5631f.y)(value)) {
    return NAN;
  }

  if ((0, _ColorPickerInput5631f.p)(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = (0, _ColorPickerInput5631f.p)(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var toNumber_1 = toNumber;
var FUNC_ERROR_TEXT = 'Expected a function';
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  wait = toNumber_1(wait) || 0;

  if ((0, _ColorPickerInput5631f.p)(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;
    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now_1();

    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }

    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    if (trailing && lastArgs) {
      return invokeFunc(time);
    }

    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }

    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }

      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }

    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }

    return result;
  }

  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;
var FUNC_ERROR_TEXT$1 = 'Expected a function';

function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }

  if ((0, _ColorPickerInput5631f.p)(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  return debounce_1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle;
var saturation = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var calculateChange = exports.calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(),
        containerWidth = _container$getBoundin.width,
        containerHeight = _container$getBoundin.height;

    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

    if (left < 0) {
      left = 0;
    } else if (left > containerWidth) {
      left = containerWidth;
    }

    if (top < 0) {
      top = 0;
    } else if (top > containerHeight) {
      top = containerHeight;
    }

    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
      h: hsl.h,
      s: saturation,
      v: bright,
      a: hsl.a,
      source: 'rgb'
    };
  };
});
(0, _chunk76875e.b)(saturation);
var saturation_1 = saturation.calculateChange;
var Saturation_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Saturation = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _throttle2 = _interopRequireDefault(throttle_1);

  var saturation$$1 = _interopRequireWildcard(saturation);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Saturation = exports.Saturation = function (_ref) {
    _inherits(Saturation, _ref);

    function Saturation(props) {
      _classCallCheck(this, Saturation);

      var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

      _this.handleChange = function (e) {
        typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation$$1.calculateChange(e, _this.props.hsl, _this.container), e);
      };

      _this.handleMouseDown = function (e) {
        _this.handleChange(e);

        window.addEventListener('mousemove', _this.handleChange);
        window.addEventListener('mouseup', _this.handleMouseUp);
      };

      _this.handleMouseUp = function () {
        _this.unbindEventListeners();
      };

      _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
        fn(data, e);
      }, 50);
      return _this;
    }

    _createClass(Saturation, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.throttle.cancel();
        this.unbindEventListeners();
      }
    }, {
      key: 'unbindEventListeners',
      value: function unbindEventListeners() {
        window.removeEventListener('mousemove', this.handleChange);
        window.removeEventListener('mouseup', this.handleMouseUp);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _ref2 = this.props.style || {},
            color = _ref2.color,
            white = _ref2.white,
            black = _ref2.black,
            pointer = _ref2.pointer,
            circle = _ref2.circle;

        var styles = (0, _reactcss2.default)({
          'default': {
            color: {
              absolute: '0px 0px 0px 0px',
              background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
              borderRadius: this.props.radius
            },
            white: {
              absolute: '0px 0px 0px 0px',
              borderRadius: this.props.radius
            },
            black: {
              absolute: '0px 0px 0px 0px',
              boxShadow: this.props.shadow,
              borderRadius: this.props.radius
            },
            pointer: {
              position: 'absolute',
              top: -(this.props.hsv.v * 100) + 100 + '%',
              left: this.props.hsv.s * 100 + '%',
              cursor: 'default'
            },
            circle: {
              width: '4px',
              height: '4px',
              boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
              borderRadius: '50%',
              cursor: 'hand',
              transform: 'translate(-2px, -2px)'
            }
          },
          'custom': {
            color: color,
            white: white,
            black: black,
            pointer: pointer,
            circle: circle
          }
        }, {
          'custom': !!this.props.style
        });
        return _react2.default.createElement('div', {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        }, _react2.default.createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), _react2.default.createElement('div', {
          style: styles.white,
          className: 'saturation-white'
        }, _react2.default.createElement('div', {
          style: styles.black,
          className: 'saturation-black'
        }), _react2.default.createElement('div', {
          style: styles.pointer
        }, this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', {
          style: styles.circle
        }))));
      }
    }]);

    return Saturation;
  }(_chunk8219403d.a.PureComponent || _chunk8219403d.a.Component);

  exports.default = Saturation;
});
(0, _chunk76875e.b)(Saturation_1);
var Saturation_2 = Saturation_1.Saturation;

function forEach(collection, iteratee) {
  var func = (0, _ColorPickerInput5631f.m)(collection) ? _ColorPickerInput5631f.z : _ColorPickerInput5631f.A;
  return func(collection, (0, _ColorPickerInput5631f.B)(iteratee));
}

var forEach_1 = forEach;
var each = forEach_1;
var color = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.red = exports.getContrastingColor = exports.isValidHex = exports.toState = exports.simpleCheckForValidColor = undefined;

  var _each2 = _interopRequireDefault(each);

  var _tinycolor2 = _interopRequireDefault(_colorutils997790c.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var simpleCheckForValidColor = exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
    var checked = 0;
    var passed = 0;
    (0, _each2.default)(keysToCheck, function (letter) {
      if (data[letter]) {
        checked += 1;

        if (!isNaN(data[letter])) {
          passed += 1;
        }

        if (letter === 's' || letter === 'l') {
          var percentPatt = /^\d+%$/;

          if (percentPatt.test(data[letter])) {
            passed += 1;
          }
        }
      }
    });
    return checked === passed ? data : false;
  };

  var toState = exports.toState = function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();

    if (hsl.s === 0) {
      hsl.h = oldHue || 0;
      hsv.h = oldHue || 0;
    }

    var transparent = hex === '000000' && rgb.a === 0;
    return {
      hsl: hsl,
      hex: transparent ? 'transparent' : '#' + hex,
      rgb: rgb,
      hsv: hsv,
      oldHue: data.h || oldHue || hsl.h,
      source: data.source
    };
  };

  var isValidHex = exports.isValidHex = function isValidHex(hex) {
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
  };

  var getContrastingColor = exports.getContrastingColor = function getContrastingColor(data) {
    if (!data) {
      return '#fff';
    }

    var col = toState(data);

    if (col.hex === 'transparent') {
      return 'rgba(0,0,0,0.4)';
    }

    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
  };

  var red = exports.red = {
    hsl: {
      a: 1,
      h: 0,
      l: 0.5,
      s: 1
    },
    hex: '#ff0000',
    rgb: {
      r: 255,
      g: 0,
      b: 0,
      a: 1
    },
    hsv: {
      h: 0,
      s: 1,
      v: 1,
      a: 1
    }
  };
  exports.default = exports;
});
(0, _chunk76875e.b)(color);
var color_1 = color.red;
var color_2 = color.getContrastingColor;
var color_3 = color.isValidHex;
var color_4 = color.toState;
var color_5 = color.simpleCheckForValidColor;
var ColorWrap_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ColorWrap = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _debounce2 = _interopRequireDefault(debounce_1);

  var _color2 = _interopRequireDefault(color);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function (_ref) {
      _inherits(ColorPicker, _ref);

      function ColorPicker(props) {
        _classCallCheck(this, ColorPicker);

        var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

        _this.handleChange = function (data, event) {
          var isValidColor = _color2.default.simpleCheckForValidColor(data);

          if (isValidColor) {
            var colors = _color2.default.toState(data, data.h || _this.state.oldHue);

            _this.setState(colors);

            _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
            _this.props.onChange && _this.props.onChange(colors, event);
          }
        };

        _this.handleSwatchHover = function (data, event) {
          var isValidColor = _color2.default.simpleCheckForValidColor(data);

          if (isValidColor) {
            var colors = _color2.default.toState(data, data.h || _this.state.oldHue);

            _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
          }
        };

        _this.state = _extends({}, _color2.default.toState(props.color, 0));
        _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
          fn(data, event);
        }, 100);
        return _this;
      }

      _createClass(ColorPicker, [{
        key: 'render',
        value: function render() {
          var optionalEvents = {};

          if (this.props.onSwatchHover) {
            optionalEvents.onSwatchHover = this.handleSwatchHover;
          }

          return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
            onChange: this.handleChange
          }, optionalEvents));
        }
      }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, state) {
          return _extends({}, _color2.default.toState(nextProps.color, state.oldHue));
        }
      }]);

      return ColorPicker;
    }(_chunk8219403d.a.PureComponent || _chunk8219403d.a.Component);

    ColorPicker.propTypes = _extends({}, Picker.propTypes);
    ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
      color: {
        h: 250,
        s: 0.50,
        l: 0.20,
        a: 1
      }
    });
    return ColorPicker;
  };

  exports.default = ColorWrap;
});
(0, _chunk76875e.b)(ColorWrap_1);
var ColorWrap_2 = ColorWrap_1.ColorWrap;
var interaction = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.handleFocus = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var handleFocus = exports.handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function (_React$Component) {
      _inherits(Focus, _React$Component);

      function Focus() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Focus);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          focus: false
        }, _this.handleFocus = function () {
          return _this.setState({
            focus: true
          });
        }, _this.handleBlur = function () {
          return _this.setState({
            focus: false
          });
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(Focus, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Span, {
            onFocus: this.handleFocus,
            onBlur: this.handleBlur
          }, _react2.default.createElement(Component, _extends({}, this.props, this.state)));
        }
      }]);

      return Focus;
    }(_react2.default.Component);
  };
});
(0, _chunk76875e.b)(interaction);
var interaction_1 = interaction.handleFocus;
var Swatch_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Swatch = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _Checkboard2 = _interopRequireDefault(Checkboard_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ENTER = 13;

  var Swatch = exports.Swatch = function Swatch(_ref) {
    var color = _ref.color,
        style = _ref.style,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
        onHover = _ref.onHover,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? color : _ref$title,
        children = _ref.children,
        focus = _ref.focus,
        _ref$focusStyle = _ref.focusStyle,
        focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, _reactcss2.default)({
      default: {
        swatch: _extends({
          background: color,
          height: '100%',
          width: '100%',
          cursor: 'pointer',
          position: 'relative',
          outline: 'none'
        }, style, focus ? focusStyle : {})
      }
    });

    var handleClick = function handleClick(e) {
      return onClick(color, e);
    };

    var handleKeyDown = function handleKeyDown(e) {
      return e.keyCode === ENTER && onClick(color, e);
    };

    var handleHover = function handleHover(e) {
      return onHover(color, e);
    };

    var optionalEvents = {};

    if (onHover) {
      optionalEvents.onMouseOver = handleHover;
    }

    return _react2.default.createElement('div', _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && _react2.default.createElement(_Checkboard2.default, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
  };

  exports.default = (0, interaction.handleFocus)(Swatch);
});
(0, _chunk76875e.b)(Swatch_1);
var Swatch_2 = Swatch_1.Swatch;
var common = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, 'Alpha', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Alpha_1).default;
    }
  });
  Object.defineProperty(exports, 'Checkboard', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Checkboard_1).default;
    }
  });
  Object.defineProperty(exports, 'EditableInput', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(EditableInput_1).default;
    }
  });
  Object.defineProperty(exports, 'Hue', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Hue_1).default;
    }
  });
  Object.defineProperty(exports, 'Raised', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Raised_1).default;
    }
  });
  Object.defineProperty(exports, 'Saturation', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Saturation_1).default;
    }
  });
  Object.defineProperty(exports, 'ColorWrap', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ColorWrap_1).default;
    }
  });
  Object.defineProperty(exports, 'Swatch', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Swatch_1).default;
    }
  });

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
});
(0, _chunk76875e.b)(common);
var AlphaPointer_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.AlphaPointer = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcss2.default)({
      'default': {
        picker: {
          width: '18px',
          height: '18px',
          borderRadius: '50%',
          transform: 'translate(-9px, -1px)',
          backgroundColor: 'rgb(248, 248, 248)',
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
        }
      },
      'vertical': {
        picker: {
          transform: 'translate(-3px, -9px)'
        }
      }
    }, {
      vertical: direction === 'vertical'
    });
    return _react2.default.createElement('div', {
      style: styles.picker
    });
  };

  exports.default = AlphaPointer;
});
(0, _chunk76875e.b)(AlphaPointer_1);
var AlphaPointer_2 = AlphaPointer_1.AlphaPointer;
var Alpha$1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.AlphaPicker = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _AlphaPointer2 = _interopRequireDefault(AlphaPointer_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
    var rgb = _ref.rgb,
        hsl = _ref.hsl,
        width = _ref.width,
        height = _ref.height,
        onChange = _ref.onChange,
        direction = _ref.direction,
        style = _ref.style,
        renderers = _ref.renderers,
        pointer = _ref.pointer,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)({
      'default': {
        picker: {
          position: 'relative',
          width: width,
          height: height
        },
        alpha: {
          radius: '2px',
          style: style
        }
      }
    });
    return _react2.default.createElement('div', {
      style: styles.picker,
      className: 'alpha-picker ' + className
    }, _react2.default.createElement(common.Alpha, _extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    })));
  };

  AlphaPicker.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: _AlphaPointer2.default
  };
  exports.default = (0, common.ColorWrap)(AlphaPicker);
});
(0, _chunk76875e.b)(Alpha$1);
var Alpha_1$1 = Alpha$1.AlphaPicker;
var BlockSwatches_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.BlockSwatches = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _map2 = _interopRequireDefault(_ColorPickerInput5631f.C);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
    var colors = _ref.colors,
        onClick = _ref.onClick,
        onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcss2.default)({
      'default': {
        swatches: {
          marginRight: '-10px'
        },
        swatch: {
          width: '22px',
          height: '22px',
          float: 'left',
          marginRight: '10px',
          marginBottom: '10px',
          borderRadius: '4px'
        },
        clear: {
          clear: 'both'
        }
      }
    });
    return _react2.default.createElement('div', {
      style: styles.swatches
    }, (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(common.Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }), _react2.default.createElement('div', {
      style: styles.clear
    }));
  };

  exports.default = BlockSwatches;
});
(0, _chunk76875e.b)(BlockSwatches_1);
var BlockSwatches_2 = BlockSwatches_1.BlockSwatches;
var Block_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Block = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _merge2 = _interopRequireDefault(merge_1);

  var _color2 = _interopRequireDefault(color);

  var _BlockSwatches2 = _interopRequireDefault(BlockSwatches_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Block = exports.Block = function Block(_ref) {
    var onChange = _ref.onChange,
        onSwatchHover = _ref.onSwatchHover,
        hex = _ref.hex,
        colors = _ref.colors,
        width = _ref.width,
        triangle = _ref.triangle,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var transparent = hex === 'transparent';

    var handleChange = function handleChange(hexCode, e) {
      _color2.default.isValidHex(hexCode) && onChange({
        hex: hexCode,
        source: 'hex'
      }, e);
    };

    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        card: {
          width: width,
          background: '#fff',
          boxShadow: '0 1px rgba(0,0,0,.1)',
          borderRadius: '6px',
          position: 'relative'
        },
        head: {
          height: '110px',
          background: hex,
          borderRadius: '6px 6px 0 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        },
        body: {
          padding: '10px'
        },
        label: {
          fontSize: '18px',
          color: _color2.default.getContrastingColor(hex),
          position: 'relative'
        },
        triangle: {
          width: '0px',
          height: '0px',
          borderStyle: 'solid',
          borderWidth: '0 10px 10px 10px',
          borderColor: 'transparent transparent ' + hex + ' transparent',
          position: 'absolute',
          top: '-10px',
          left: '50%',
          marginLeft: '-10px'
        },
        input: {
          width: '100%',
          fontSize: '12px',
          color: '#666',
          border: '0px',
          outline: 'none',
          height: '22px',
          boxShadow: 'inset 0 0 0 1px #ddd',
          borderRadius: '4px',
          padding: '0 7px',
          boxSizing: 'border-box'
        }
      },
      'hide-triangle': {
        triangle: {
          display: 'none'
        }
      }
    }, passedStyles), {
      'hide-triangle': triangle === 'hide'
    });
    return _react2.default.createElement('div', {
      style: styles.card,
      className: 'block-picker ' + className
    }, _react2.default.createElement('div', {
      style: styles.triangle
    }), _react2.default.createElement('div', {
      style: styles.head
    }, transparent && _react2.default.createElement(common.Checkboard, {
      borderRadius: '6px 6px 0 0'
    }), _react2.default.createElement('div', {
      style: styles.label
    }, hex)), _react2.default.createElement('div', {
      style: styles.body
    }, _react2.default.createElement(_BlockSwatches2.default, {
      colors: colors,
      onClick: handleChange,
      onSwatchHover: onSwatchHover
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        input: styles.input
      },
      value: hex,
      onChange: handleChange
    })));
  };

  Block.propTypes = {
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
    triangle: _propTypes2.default.oneOf(['top', 'hide']),
    styles: _propTypes2.default.object
  };
  Block.defaultProps = {
    width: 170,
    colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
    triangle: 'top',
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(Block);
});
(0, _chunk76875e.b)(Block_1);
var Block_2 = Block_1.Block;
var red = {
  "50": "#ffebee",
  "100": "#ffcdd2",
  "200": "#ef9a9a",
  "300": "#e57373",
  "400": "#ef5350",
  "500": "#f44336",
  "600": "#e53935",
  "700": "#d32f2f",
  "800": "#c62828",
  "900": "#b71c1c",
  "a100": "#ff8a80",
  "a200": "#ff5252",
  "a400": "#ff1744",
  "a700": "#d50000"
};
var pink = {
  "50": "#fce4ec",
  "100": "#f8bbd0",
  "200": "#f48fb1",
  "300": "#f06292",
  "400": "#ec407a",
  "500": "#e91e63",
  "600": "#d81b60",
  "700": "#c2185b",
  "800": "#ad1457",
  "900": "#880e4f",
  "a100": "#ff80ab",
  "a200": "#ff4081",
  "a400": "#f50057",
  "a700": "#c51162"
};
var purple = {
  "50": "#f3e5f5",
  "100": "#e1bee7",
  "200": "#ce93d8",
  "300": "#ba68c8",
  "400": "#ab47bc",
  "500": "#9c27b0",
  "600": "#8e24aa",
  "700": "#7b1fa2",
  "800": "#6a1b9a",
  "900": "#4a148c",
  "a100": "#ea80fc",
  "a200": "#e040fb",
  "a400": "#d500f9",
  "a700": "#aa00ff"
};
var deepPurple = {
  "50": "#ede7f6",
  "100": "#d1c4e9",
  "200": "#b39ddb",
  "300": "#9575cd",
  "400": "#7e57c2",
  "500": "#673ab7",
  "600": "#5e35b1",
  "700": "#512da8",
  "800": "#4527a0",
  "900": "#311b92",
  "a100": "#b388ff",
  "a200": "#7c4dff",
  "a400": "#651fff",
  "a700": "#6200ea"
};
var indigo = {
  "50": "#e8eaf6",
  "100": "#c5cae9",
  "200": "#9fa8da",
  "300": "#7986cb",
  "400": "#5c6bc0",
  "500": "#3f51b5",
  "600": "#3949ab",
  "700": "#303f9f",
  "800": "#283593",
  "900": "#1a237e",
  "a100": "#8c9eff",
  "a200": "#536dfe",
  "a400": "#3d5afe",
  "a700": "#304ffe"
};
var blue = {
  "50": "#e3f2fd",
  "100": "#bbdefb",
  "200": "#90caf9",
  "300": "#64b5f6",
  "400": "#42a5f5",
  "500": "#2196f3",
  "600": "#1e88e5",
  "700": "#1976d2",
  "800": "#1565c0",
  "900": "#0d47a1",
  "a100": "#82b1ff",
  "a200": "#448aff",
  "a400": "#2979ff",
  "a700": "#2962ff"
};
var lightBlue = {
  "50": "#e1f5fe",
  "100": "#b3e5fc",
  "200": "#81d4fa",
  "300": "#4fc3f7",
  "400": "#29b6f6",
  "500": "#03a9f4",
  "600": "#039be5",
  "700": "#0288d1",
  "800": "#0277bd",
  "900": "#01579b",
  "a100": "#80d8ff",
  "a200": "#40c4ff",
  "a400": "#00b0ff",
  "a700": "#0091ea"
};
var cyan = {
  "50": "#e0f7fa",
  "100": "#b2ebf2",
  "200": "#80deea",
  "300": "#4dd0e1",
  "400": "#26c6da",
  "500": "#00bcd4",
  "600": "#00acc1",
  "700": "#0097a7",
  "800": "#00838f",
  "900": "#006064",
  "a100": "#84ffff",
  "a200": "#18ffff",
  "a400": "#00e5ff",
  "a700": "#00b8d4"
};
var teal = {
  "50": "#e0f2f1",
  "100": "#b2dfdb",
  "200": "#80cbc4",
  "300": "#4db6ac",
  "400": "#26a69a",
  "500": "#009688",
  "600": "#00897b",
  "700": "#00796b",
  "800": "#00695c",
  "900": "#004d40",
  "a100": "#a7ffeb",
  "a200": "#64ffda",
  "a400": "#1de9b6",
  "a700": "#00bfa5"
};
var green = {
  "50": "#e8f5e9",
  "100": "#c8e6c9",
  "200": "#a5d6a7",
  "300": "#81c784",
  "400": "#66bb6a",
  "500": "#4caf50",
  "600": "#43a047",
  "700": "#388e3c",
  "800": "#2e7d32",
  "900": "#1b5e20",
  "a100": "#b9f6ca",
  "a200": "#69f0ae",
  "a400": "#00e676",
  "a700": "#00c853"
};
var lightGreen = {
  "50": "#f1f8e9",
  "100": "#dcedc8",
  "200": "#c5e1a5",
  "300": "#aed581",
  "400": "#9ccc65",
  "500": "#8bc34a",
  "600": "#7cb342",
  "700": "#689f38",
  "800": "#558b2f",
  "900": "#33691e",
  "a100": "#ccff90",
  "a200": "#b2ff59",
  "a400": "#76ff03",
  "a700": "#64dd17"
};
var lime = {
  "50": "#f9fbe7",
  "100": "#f0f4c3",
  "200": "#e6ee9c",
  "300": "#dce775",
  "400": "#d4e157",
  "500": "#cddc39",
  "600": "#c0ca33",
  "700": "#afb42b",
  "800": "#9e9d24",
  "900": "#827717",
  "a100": "#f4ff81",
  "a200": "#eeff41",
  "a400": "#c6ff00",
  "a700": "#aeea00"
};
var yellow = {
  "50": "#fffde7",
  "100": "#fff9c4",
  "200": "#fff59d",
  "300": "#fff176",
  "400": "#ffee58",
  "500": "#ffeb3b",
  "600": "#fdd835",
  "700": "#fbc02d",
  "800": "#f9a825",
  "900": "#f57f17",
  "a100": "#ffff8d",
  "a200": "#ffff00",
  "a400": "#ffea00",
  "a700": "#ffd600"
};
var amber = {
  "50": "#fff8e1",
  "100": "#ffecb3",
  "200": "#ffe082",
  "300": "#ffd54f",
  "400": "#ffca28",
  "500": "#ffc107",
  "600": "#ffb300",
  "700": "#ffa000",
  "800": "#ff8f00",
  "900": "#ff6f00",
  "a100": "#ffe57f",
  "a200": "#ffd740",
  "a400": "#ffc400",
  "a700": "#ffab00"
};
var orange = {
  "50": "#fff3e0",
  "100": "#ffe0b2",
  "200": "#ffcc80",
  "300": "#ffb74d",
  "400": "#ffa726",
  "500": "#ff9800",
  "600": "#fb8c00",
  "700": "#f57c00",
  "800": "#ef6c00",
  "900": "#e65100",
  "a100": "#ffd180",
  "a200": "#ffab40",
  "a400": "#ff9100",
  "a700": "#ff6d00"
};
var deepOrange = {
  "50": "#fbe9e7",
  "100": "#ffccbc",
  "200": "#ffab91",
  "300": "#ff8a65",
  "400": "#ff7043",
  "500": "#ff5722",
  "600": "#f4511e",
  "700": "#e64a19",
  "800": "#d84315",
  "900": "#bf360c",
  "a100": "#ff9e80",
  "a200": "#ff6e40",
  "a400": "#ff3d00",
  "a700": "#dd2c00"
};
var brown = {
  "50": "#efebe9",
  "100": "#d7ccc8",
  "200": "#bcaaa4",
  "300": "#a1887f",
  "400": "#8d6e63",
  "500": "#795548",
  "600": "#6d4c41",
  "700": "#5d4037",
  "800": "#4e342e",
  "900": "#3e2723"
};
var grey = {
  "50": "#fafafa",
  "100": "#f5f5f5",
  "200": "#eeeeee",
  "300": "#e0e0e0",
  "400": "#bdbdbd",
  "500": "#9e9e9e",
  "600": "#757575",
  "700": "#616161",
  "800": "#424242",
  "900": "#212121"
};
var blueGrey = {
  "50": "#eceff1",
  "100": "#cfd8dc",
  "200": "#b0bec5",
  "300": "#90a4ae",
  "400": "#78909c",
  "500": "#607d8b",
  "600": "#546e7a",
  "700": "#455a64",
  "800": "#37474f",
  "900": "#263238"
};
var darkText = {
  "primary": "rgba(0, 0, 0, 0.87)",
  "secondary": "rgba(0, 0, 0, 0.54)",
  "disabled": "rgba(0, 0, 0, 0.38)",
  "dividers": "rgba(0, 0, 0, 0.12)"
};
var lightText = {
  "primary": "rgba(255, 255, 255, 1)",
  "secondary": "rgba(255, 255, 255, 0.7)",
  "disabled": "rgba(255, 255, 255, 0.5)",
  "dividers": "rgba(255, 255, 255, 0.12)"
};
var darkIcons = {
  "active": "rgba(0, 0, 0, 0.54)",
  "inactive": "rgba(0, 0, 0, 0.38)"
};
var lightIcons = {
  "active": "rgba(255, 255, 255, 1)",
  "inactive": "rgba(255, 255, 255, 0.5)"
};
var white = "#ffffff";
var black = "#000000";
var _materialColors = {
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  grey: grey,
  blueGrey: blueGrey,
  darkText: darkText,
  lightText: lightText,
  darkIcons: darkIcons,
  lightIcons: lightIcons,
  white: white,
  black: black
};
var CircleSwatch_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CircleSwatch = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
    var color = _ref.color,
        onClick = _ref.onClick,
        onSwatchHover = _ref.onSwatchHover,
        hover = _ref.hover,
        active = _ref.active,
        circleSize = _ref.circleSize,
        circleSpacing = _ref.circleSpacing;
    var styles = (0, _reactcss2.default)({
      'default': {
        swatch: {
          width: circleSize,
          height: circleSize,
          marginRight: circleSpacing,
          marginBottom: circleSpacing,
          transform: 'scale(1)',
          transition: '100ms transform ease'
        },
        Swatch: {
          borderRadius: '50%',
          background: 'transparent',
          boxShadow: 'inset 0 0 0 ' + circleSize / 2 + 'px ' + color,
          transition: '100ms box-shadow ease'
        }
      },
      'hover': {
        swatch: {
          transform: 'scale(1.2)'
        }
      },
      'active': {
        Swatch: {
          boxShadow: 'inset 0 0 0 3px ' + color
        }
      }
    }, {
      hover: hover,
      active: active
    });
    return _react2.default.createElement('div', {
      style: styles.swatch
    }, _react2.default.createElement(common.Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
      }
    }));
  };

  CircleSwatch.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
  };
  exports.default = (0, _ColorPickerInput5631f.a.handleHover)(CircleSwatch);
});
(0, _chunk76875e.b)(CircleSwatch_1);
var CircleSwatch_2 = CircleSwatch_1.CircleSwatch;
var Circle_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Circle = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _map2 = _interopRequireDefault(_ColorPickerInput5631f.C);

  var _merge2 = _interopRequireDefault(merge_1);

  var material = _interopRequireWildcard(_materialColors);

  var _CircleSwatch2 = _interopRequireDefault(CircleSwatch_1);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Circle = exports.Circle = function Circle(_ref) {
    var width = _ref.width,
        onChange = _ref.onChange,
        onSwatchHover = _ref.onSwatchHover,
        colors = _ref.colors,
        hex = _ref.hex,
        circleSize = _ref.circleSize,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        circleSpacing = _ref.circleSpacing,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        card: {
          width: width,
          display: 'flex',
          flexWrap: 'wrap',
          marginRight: -circleSpacing,
          marginBottom: -circleSpacing
        }
      }
    }, passedStyles));

    var handleChange = function handleChange(hexCode, e) {
      return onChange({
        hex: hexCode,
        source: 'hex'
      }, e);
    };

    return _react2.default.createElement('div', {
      style: styles.card,
      className: 'circle-picker ' + className
    }, (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_CircleSwatch2.default, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    }));
  };

  Circle.propTypes = {
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    circleSize: _propTypes2.default.number,
    circleSpacing: _propTypes2.default.number,
    styles: _propTypes2.default.object
  };
  Circle.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']],
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(Circle);
});
(0, _chunk76875e.b)(Circle_1);
var Circle_2 = Circle_1.Circle;
var UnfoldMoreHorizontalIcon = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties$$1(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var DEFAULT_SIZE = 24;

  exports.default = function (_ref) {
    var _ref$fill = _ref.fill,
        fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        props = _objectWithoutProperties$$1(_ref, ['fill', 'width', 'height', 'style']);

    return _react2.default.createElement('svg', _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({
        fill: fill,
        width: width,
        height: height
      }, style)
    }, props), _react2.default.createElement('path', {
      d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
    }));
  };
});
(0, _chunk76875e.b)(UnfoldMoreHorizontalIcon);
var ChromeFields_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ChromeFields = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _color2 = _interopRequireDefault(color);

  var _UnfoldMoreHorizontalIcon2 = _interopRequireDefault(UnfoldMoreHorizontalIcon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ChromeFields = exports.ChromeFields = function (_React$Component) {
    _inherits(ChromeFields, _React$Component);

    function ChromeFields(props) {
      _classCallCheck(this, ChromeFields);

      var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

      _this.toggleViews = function () {
        if (_this.state.view === 'hex') {
          _this.setState({
            view: 'rgb'
          });
        } else if (_this.state.view === 'rgb') {
          _this.setState({
            view: 'hsl'
          });
        } else if (_this.state.view === 'hsl') {
          if (_this.props.hsl.a === 1) {
            _this.setState({
              view: 'hex'
            });
          } else {
            _this.setState({
              view: 'rgb'
            });
          }
        }
      };

      _this.handleChange = function (data, e) {
        if (data.hex) {
          _color2.default.isValidHex(data.hex) && _this.props.onChange({
            hex: data.hex,
            source: 'hex'
          }, e);
        } else if (data.r || data.g || data.b) {
          _this.props.onChange({
            r: data.r || _this.props.rgb.r,
            g: data.g || _this.props.rgb.g,
            b: data.b || _this.props.rgb.b,
            source: 'rgb'
          }, e);
        } else if (data.a) {
          if (data.a < 0) {
            data.a = 0;
          } else if (data.a > 1) {
            data.a = 1;
          }

          _this.props.onChange({
            h: _this.props.hsl.h,
            s: _this.props.hsl.s,
            l: _this.props.hsl.l,
            a: Math.round(data.a * 100) / 100,
            source: 'rgb'
          }, e);
        } else if (data.h || data.s || data.l) {
          if (typeof data.s === 'string' && data.s.includes('%')) {
            data.s = data.s.replace('%', '');
          }

          if (typeof data.l === 'string' && data.l.includes('%')) {
            data.l = data.l.replace('%', '');
          }

          _this.props.onChange({
            h: data.h || _this.props.hsl.h,
            s: Number(data.s && data.s || _this.props.hsl.s),
            l: Number(data.l && data.l || _this.props.hsl.l),
            source: 'hsl'
          }, e);
        }
      };

      _this.showHighlight = function (e) {
        e.currentTarget.style.background = '#eee';
      };

      _this.hideHighlight = function (e) {
        e.currentTarget.style.background = 'transparent';
      };

      if (props.hsl.a !== 1 && props.view === "hex") {
        _this.state = {
          view: "rgb"
        };
      } else {
        _this.state = {
          view: props.view
        };
      }

      return _this;
    }

    _createClass(ChromeFields, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var styles = (0, _reactcss2.default)({
          'default': {
            wrap: {
              paddingTop: '16px',
              display: 'flex'
            },
            fields: {
              flex: '1',
              display: 'flex',
              marginLeft: '-6px'
            },
            field: {
              paddingLeft: '6px',
              width: '100%'
            },
            alpha: {
              paddingLeft: '6px',
              width: '100%'
            },
            toggle: {
              width: '32px',
              textAlign: 'right',
              position: 'relative'
            },
            icon: {
              marginRight: '-4px',
              marginTop: '12px',
              cursor: 'pointer',
              position: 'relative'
            },
            iconHighlight: {
              position: 'absolute',
              width: '24px',
              height: '28px',
              background: '#eee',
              borderRadius: '4px',
              top: '10px',
              left: '12px',
              display: 'none'
            },
            input: {
              fontSize: '11px',
              color: '#333',
              width: '100%',
              borderRadius: '2px',
              border: 'none',
              boxShadow: 'inset 0 0 0 1px #dadada',
              height: '21px',
              textAlign: 'center'
            },
            label: {
              textTransform: 'uppercase',
              fontSize: '11px',
              lineHeight: '11px',
              color: '#969696',
              textAlign: 'center',
              display: 'block',
              marginTop: '12px'
            },
            svg: {
              fill: '#333',
              width: '24px',
              height: '24px',
              border: '1px transparent solid',
              borderRadius: '5px'
            }
          },
          'disableAlpha': {
            alpha: {
              display: 'none'
            }
          }
        }, this.props, this.state);
        var fields = void 0;

        if (this.state.view === 'hex') {
          fields = _react2.default.createElement('div', {
            style: styles.fields,
            className: 'flexbox-fix'
          }, _react2.default.createElement('div', {
            style: styles.field
          }, _react2.default.createElement(common.EditableInput, {
            style: {
              input: styles.input,
              label: styles.label
            },
            label: 'hex',
            value: this.props.hex,
            onChange: this.handleChange
          })));
        } else if (this.state.view === 'rgb') {
          fields = _react2.default.createElement('div', {
            style: styles.fields,
            className: 'flexbox-fix'
          }, _react2.default.createElement('div', {
            style: styles.field
          }, _react2.default.createElement(common.EditableInput, {
            style: {
              input: styles.input,
              label: styles.label
            },
            label: 'r',
            value: this.props.rgb.r,
            onChange: this.handleChange
          })), _react2.default.createElement('div', {
            style: styles.field
          }, _react2.default.createElement(common.EditableInput, {
            style: {
              input: styles.input,
              label: styles.label
            },
            label: 'g',
            value: this.props.rgb.g,
            onChange: this.handleChange
          })), _react2.default.createElement('div', {
            style: styles.field
          }, _react2.default.createElement(common.EditableInput, {
            style: {
              input: styles.input,
              label: styles.label
            },
            label: 'b',
            value: this.props.rgb.b,
            onChange: this.handleChange
          })), _react2.default.createElement('div', {
            style: styles.alpha
          }, _react2.default.createElement(common.EditableInput, {
            style: {
              input: styles.input,
              label: styles.label
            },
            label: 'a',
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })));
        } else if (this.state.view === 'hsl') {
          fields = _react2.default.createElement('div', {
            style: styles.fields,
            className: 'flexbox-fix'
          }, _react2.default.createElement('div', {
            style: styles.field
          }, _react2.default.createElement(common.EditableInput, {
            style: {
              input: styles.input,
              label: styles.label
            },
            label: 'h',
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })), _react2.default.createElement('div', {
            style: styles.field
          }, _react2.default.createElement(common.EditableInput, {
            style: {
              input: styles.input,
              label: styles.label
            },
            label: 's',
            value: Math.round(this.props.hsl.s * 100) + '%',
            onChange: this.handleChange
          })), _react2.default.createElement('div', {
            style: styles.field
          }, _react2.default.createElement(common.EditableInput, {
            style: {
              input: styles.input,
              label: styles.label
            },
            label: 'l',
            value: Math.round(this.props.hsl.l * 100) + '%',
            onChange: this.handleChange
          })), _react2.default.createElement('div', {
            style: styles.alpha
          }, _react2.default.createElement(common.EditableInput, {
            style: {
              input: styles.input,
              label: styles.label
            },
            label: 'a',
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })));
        }

        return _react2.default.createElement('div', {
          style: styles.wrap,
          className: 'flexbox-fix'
        }, fields, _react2.default.createElement('div', {
          style: styles.toggle
        }, _react2.default.createElement('div', {
          style: styles.icon,
          onClick: this.toggleViews,
          ref: function ref(icon) {
            return _this2.icon = icon;
          }
        }, _react2.default.createElement(_UnfoldMoreHorizontalIcon2.default, {
          style: styles.svg,
          onMouseOver: this.showHighlight,
          onMouseEnter: this.showHighlight,
          onMouseOut: this.hideHighlight
        }))));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        if (nextProps.hsl.a !== 1 && state.view === 'hex') {
          return {
            view: 'rgb'
          };
        }

        return null;
      }
    }]);

    return ChromeFields;
  }(_react2.default.Component);

  ChromeFields.defaultProps = {
    view: "hex"
  };
  exports.default = ChromeFields;
});
(0, _chunk76875e.b)(ChromeFields_1);
var ChromeFields_2 = ChromeFields_1.ChromeFields;
var ChromePointer_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ChromePointer = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ChromePointer = exports.ChromePointer = function ChromePointer() {
    var styles = (0, _reactcss2.default)({
      'default': {
        picker: {
          width: '12px',
          height: '12px',
          borderRadius: '6px',
          transform: 'translate(-6px, -1px)',
          backgroundColor: 'rgb(248, 248, 248)',
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
        }
      }
    });
    return _react2.default.createElement('div', {
      style: styles.picker
    });
  };

  exports.default = ChromePointer;
});
(0, _chunk76875e.b)(ChromePointer_1);
var ChromePointer_2 = ChromePointer_1.ChromePointer;
var ChromePointerCircle_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ChromePointerCircle = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
    var styles = (0, _reactcss2.default)({
      'default': {
        picker: {
          width: '12px',
          height: '12px',
          borderRadius: '6px',
          boxShadow: 'inset 0 0 0 1px #fff',
          transform: 'translate(-6px, -6px)'
        }
      }
    });
    return _react2.default.createElement('div', {
      style: styles.picker
    });
  };

  exports.default = ChromePointerCircle;
});
(0, _chunk76875e.b)(ChromePointerCircle_1);
var ChromePointerCircle_2 = ChromePointerCircle_1.ChromePointerCircle;
var Chrome_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Chrome = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _merge2 = _interopRequireDefault(merge_1);

  var _ChromeFields2 = _interopRequireDefault(ChromeFields_1);

  var _ChromePointer2 = _interopRequireDefault(ChromePointer_1);

  var _ChromePointerCircle2 = _interopRequireDefault(ChromePointerCircle_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Chrome = exports.Chrome = function Chrome(_ref) {
    var width = _ref.width,
        onChange = _ref.onChange,
        disableAlpha = _ref.disableAlpha,
        rgb = _ref.rgb,
        hsl = _ref.hsl,
        hsv = _ref.hsv,
        hex = _ref.hex,
        renderers = _ref.renderers,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        defaultView = _ref.defaultView;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        picker: {
          width: width,
          background: '#fff',
          borderRadius: '2px',
          boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
          boxSizing: 'initial',
          fontFamily: 'Menlo'
        },
        saturation: {
          width: '100%',
          paddingBottom: '55%',
          position: 'relative',
          borderRadius: '2px 2px 0 0',
          overflow: 'hidden'
        },
        Saturation: {
          radius: '2px 2px 0 0'
        },
        body: {
          padding: '16px 16px 12px'
        },
        controls: {
          display: 'flex'
        },
        color: {
          width: '32px'
        },
        swatch: {
          marginTop: '6px',
          width: '16px',
          height: '16px',
          borderRadius: '8px',
          position: 'relative',
          overflow: 'hidden'
        },
        active: {
          absolute: '0px 0px 0px 0px',
          borderRadius: '8px',
          boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
          background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
          zIndex: '2'
        },
        toggles: {
          flex: '1'
        },
        hue: {
          height: '10px',
          position: 'relative',
          marginBottom: '8px'
        },
        Hue: {
          radius: '2px'
        },
        alpha: {
          height: '10px',
          position: 'relative'
        },
        Alpha: {
          radius: '2px'
        }
      },
      'disableAlpha': {
        color: {
          width: '22px'
        },
        alpha: {
          display: 'none'
        },
        hue: {
          marginBottom: '0px'
        },
        swatch: {
          width: '10px',
          height: '10px',
          marginTop: '0px'
        }
      }
    }, passedStyles), {
      disableAlpha: disableAlpha
    });
    return _react2.default.createElement('div', {
      style: styles.picker,
      className: 'chrome-picker ' + className
    }, _react2.default.createElement('div', {
      style: styles.saturation
    }, _react2.default.createElement(common.Saturation, {
      style: styles.Saturation,
      hsl: hsl,
      hsv: hsv,
      pointer: _ChromePointerCircle2.default,
      onChange: onChange
    })), _react2.default.createElement('div', {
      style: styles.body
    }, _react2.default.createElement('div', {
      style: styles.controls,
      className: 'flexbox-fix'
    }, _react2.default.createElement('div', {
      style: styles.color
    }, _react2.default.createElement('div', {
      style: styles.swatch
    }, _react2.default.createElement('div', {
      style: styles.active
    }), _react2.default.createElement(common.Checkboard, {
      renderers: renderers
    }))), _react2.default.createElement('div', {
      style: styles.toggles
    }, _react2.default.createElement('div', {
      style: styles.hue
    }, _react2.default.createElement(common.Hue, {
      style: styles.Hue,
      hsl: hsl,
      pointer: _ChromePointer2.default,
      onChange: onChange
    })), _react2.default.createElement('div', {
      style: styles.alpha
    }, _react2.default.createElement(common.Alpha, {
      style: styles.Alpha,
      rgb: rgb,
      hsl: hsl,
      pointer: _ChromePointer2.default,
      renderers: renderers,
      onChange: onChange
    })))), _react2.default.createElement(_ChromeFields2.default, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      view: defaultView,
      onChange: onChange,
      disableAlpha: disableAlpha
    })));
  };

  Chrome.propTypes = {
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    disableAlpha: _propTypes2.default.bool,
    styles: _propTypes2.default.object,
    defaultView: _propTypes2.default.oneOf(["hex", "rgb", "hsl"])
  };
  Chrome.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(Chrome);
});
(0, _chunk76875e.b)(Chrome_1);
var Chrome_2 = Chrome_1.Chrome;
var CompactColor_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CompactColor = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _color2 = _interopRequireDefault(color);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CompactColor = exports.CompactColor = function CompactColor(_ref) {
    var color$$1 = _ref.color,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
        onSwatchHover = _ref.onSwatchHover,
        active = _ref.active;
    var styles = (0, _reactcss2.default)({
      'default': {
        color: {
          background: color$$1,
          width: '15px',
          height: '15px',
          float: 'left',
          marginRight: '5px',
          marginBottom: '5px',
          position: 'relative',
          cursor: 'pointer'
        },
        dot: {
          absolute: '5px 5px 5px 5px',
          background: _color2.default.getContrastingColor(color$$1),
          borderRadius: '50%',
          opacity: '0'
        }
      },
      'active': {
        dot: {
          opacity: '1'
        }
      },
      'color-#FFFFFF': {
        color: {
          boxShadow: 'inset 0 0 0 1px #ddd'
        },
        dot: {
          background: '#000'
        }
      },
      'transparent': {
        dot: {
          background: '#000'
        }
      }
    }, {
      active: active,
      'color-#FFFFFF': color$$1 === '#FFFFFF',
      'transparent': color$$1 === 'transparent'
    });
    return _react2.default.createElement(common.Swatch, {
      style: styles.color,
      color: color$$1,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: '0 0 4px ' + color$$1
      }
    }, _react2.default.createElement('div', {
      style: styles.dot
    }));
  };

  exports.default = CompactColor;
});
(0, _chunk76875e.b)(CompactColor_1);
var CompactColor_2 = CompactColor_1.CompactColor;
var CompactFields_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CompactFields = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var CompactFields = exports.CompactFields = function CompactFields(_ref) {
    var hex = _ref.hex,
        rgb = _ref.rgb,
        onChange = _ref.onChange;
    var styles = (0, _reactcss2.default)({
      'default': {
        fields: {
          display: 'flex',
          paddingBottom: '6px',
          paddingRight: '5px',
          position: 'relative'
        },
        active: {
          position: 'absolute',
          top: '6px',
          left: '5px',
          height: '9px',
          width: '9px',
          background: hex
        },
        HEXwrap: {
          flex: '6',
          position: 'relative'
        },
        HEXinput: {
          width: '80%',
          padding: '0px',
          paddingLeft: '20%',
          border: 'none',
          outline: 'none',
          background: 'none',
          fontSize: '12px',
          color: '#333',
          height: '16px'
        },
        HEXlabel: {
          display: 'none'
        },
        RGBwrap: {
          flex: '3',
          position: 'relative'
        },
        RGBinput: {
          width: '70%',
          padding: '0px',
          paddingLeft: '30%',
          border: 'none',
          outline: 'none',
          background: 'none',
          fontSize: '12px',
          color: '#333',
          height: '16px'
        },
        RGBlabel: {
          position: 'absolute',
          top: '3px',
          left: '0px',
          lineHeight: '16px',
          textTransform: 'uppercase',
          fontSize: '12px',
          color: '#999'
        }
      }
    });

    var handleChange = function handleChange(data, e) {
      if (data.r || data.g || data.b) {
        onChange({
          r: data.r || rgb.r,
          g: data.g || rgb.g,
          b: data.b || rgb.b,
          source: 'rgb'
        }, e);
      } else {
        onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      }
    };

    return _react2.default.createElement('div', {
      style: styles.fields,
      className: 'flexbox-fix'
    }, _react2.default.createElement('div', {
      style: styles.active
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.HEXwrap,
        input: styles.HEXinput,
        label: styles.HEXlabel
      },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }));
  };

  exports.default = CompactFields;
});
(0, _chunk76875e.b)(CompactFields_1);
var CompactFields_2 = CompactFields_1.CompactFields;
var Compact_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Compact = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _map2 = _interopRequireDefault(_ColorPickerInput5631f.C);

  var _merge2 = _interopRequireDefault(merge_1);

  var _color2 = _interopRequireDefault(color);

  var _CompactColor2 = _interopRequireDefault(CompactColor_1);

  var _CompactFields2 = _interopRequireDefault(CompactFields_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Compact = exports.Compact = function Compact(_ref) {
    var onChange = _ref.onChange,
        onSwatchHover = _ref.onSwatchHover,
        colors = _ref.colors,
        hex = _ref.hex,
        rgb = _ref.rgb,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        Compact: {
          background: '#f6f6f6',
          radius: '4px'
        },
        compact: {
          paddingTop: '5px',
          paddingLeft: '5px',
          boxSizing: 'initial',
          width: '240px'
        },
        clear: {
          clear: 'both'
        }
      }
    }, passedStyles));

    var handleChange = function handleChange(data, e) {
      if (data.hex) {
        _color2.default.isValidHex(data.hex) && onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else {
        onChange(data, e);
      }
    };

    return _react2.default.createElement(common.Raised, {
      style: styles.Compact,
      styles: passedStyles
    }, _react2.default.createElement('div', {
      style: styles.compact,
      className: 'compact-picker ' + className
    }, _react2.default.createElement('div', null, (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_CompactColor2.default, {
        key: c,
        color: c,
        active: c.toLowerCase() === hex,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    }), _react2.default.createElement('div', {
      style: styles.clear
    })), _react2.default.createElement(_CompactFields2.default, {
      hex: hex,
      rgb: rgb,
      onChange: handleChange
    })));
  };

  Compact.propTypes = {
    colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
    styles: _propTypes2.default.object
  };
  Compact.defaultProps = {
    colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(Compact);
});
(0, _chunk76875e.b)(Compact_1);
var Compact_2 = Compact_1.Compact;
var GithubSwatch_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.GithubSwatch = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
    var hover = _ref.hover,
        color = _ref.color,
        onClick = _ref.onClick,
        onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
      position: 'relative',
      zIndex: '2',
      outline: '2px solid #fff',
      boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
    };
    var styles = (0, _reactcss2.default)({
      'default': {
        swatch: {
          width: '25px',
          height: '25px',
          fontSize: '0'
        }
      },
      'hover': {
        swatch: hoverSwatch
      }
    }, {
      hover: hover
    });
    return _react2.default.createElement('div', {
      style: styles.swatch
    }, _react2.default.createElement(common.Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    }));
  };

  exports.default = (0, _ColorPickerInput5631f.a.handleHover)(GithubSwatch);
});
(0, _chunk76875e.b)(GithubSwatch_1);
var GithubSwatch_2 = GithubSwatch_1.GithubSwatch;
var Github_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Github = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _map2 = _interopRequireDefault(_ColorPickerInput5631f.C);

  var _merge2 = _interopRequireDefault(merge_1);

  var _GithubSwatch2 = _interopRequireDefault(GithubSwatch_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Github = exports.Github = function Github(_ref) {
    var width = _ref.width,
        colors = _ref.colors,
        onChange = _ref.onChange,
        onSwatchHover = _ref.onSwatchHover,
        triangle = _ref.triangle,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        card: {
          width: width,
          background: '#fff',
          border: '1px solid rgba(0,0,0,0.2)',
          boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
          borderRadius: '4px',
          position: 'relative',
          padding: '5px',
          display: 'flex',
          flexWrap: 'wrap'
        },
        triangle: {
          position: 'absolute',
          border: '7px solid transparent',
          borderBottomColor: '#fff'
        },
        triangleShadow: {
          position: 'absolute',
          border: '8px solid transparent',
          borderBottomColor: 'rgba(0,0,0,0.15)'
        }
      },
      'hide-triangle': {
        triangle: {
          display: 'none'
        },
        triangleShadow: {
          display: 'none'
        }
      },
      'top-left-triangle': {
        triangle: {
          top: '-14px',
          left: '10px'
        },
        triangleShadow: {
          top: '-16px',
          left: '9px'
        }
      },
      'top-right-triangle': {
        triangle: {
          top: '-14px',
          right: '10px'
        },
        triangleShadow: {
          top: '-16px',
          right: '9px'
        }
      },
      'bottom-left-triangle': {
        triangle: {
          top: '35px',
          left: '10px',
          transform: 'rotate(180deg)'
        },
        triangleShadow: {
          top: '37px',
          left: '9px',
          transform: 'rotate(180deg)'
        }
      },
      'bottom-right-triangle': {
        triangle: {
          top: '35px',
          right: '10px',
          transform: 'rotate(180deg)'
        },
        triangleShadow: {
          top: '37px',
          right: '9px',
          transform: 'rotate(180deg)'
        }
      }
    }, passedStyles), {
      'hide-triangle': triangle === 'hide',
      'top-left-triangle': triangle === 'top-left',
      'top-right-triangle': triangle === 'top-right',
      'bottom-left-triangle': triangle === 'bottom-left',
      'bottom-right-triangle': triangle === 'bottom-right'
    });

    var handleChange = function handleChange(hex, e) {
      return onChange({
        hex: hex,
        source: 'hex'
      }, e);
    };

    return _react2.default.createElement('div', {
      style: styles.card,
      className: 'github-picker ' + className
    }, _react2.default.createElement('div', {
      style: styles.triangleShadow
    }), _react2.default.createElement('div', {
      style: styles.triangle
    }), (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_GithubSwatch2.default, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    }));
  };

  Github.propTypes = {
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
    triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
    styles: _propTypes2.default.object
  };
  Github.defaultProps = {
    width: 200,
    colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
    triangle: 'top-left',
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(Github);
});
(0, _chunk76875e.b)(Github_1);
var Github_2 = Github_1.Github;
var HuePointer = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SliderPointer = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcss2.default)({
      'default': {
        picker: {
          width: '18px',
          height: '18px',
          borderRadius: '50%',
          transform: 'translate(-9px, -1px)',
          backgroundColor: 'rgb(248, 248, 248)',
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
        }
      },
      'vertical': {
        picker: {
          transform: 'translate(-3px, -9px)'
        }
      }
    }, {
      vertical: direction === 'vertical'
    });
    return _react2.default.createElement('div', {
      style: styles.picker
    });
  };

  exports.default = SliderPointer;
});
(0, _chunk76875e.b)(HuePointer);
var HuePointer_1 = HuePointer.SliderPointer;
var Hue$1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.HuePicker = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _merge2 = _interopRequireDefault(merge_1);

  var _HuePointer2 = _interopRequireDefault(HuePointer);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var HuePicker = exports.HuePicker = function HuePicker(_ref) {
    var width = _ref.width,
        height = _ref.height,
        onChange = _ref.onChange,
        hsl = _ref.hsl,
        direction = _ref.direction,
        pointer = _ref.pointer,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        picker: {
          position: 'relative',
          width: width,
          height: height
        },
        hue: {
          radius: '2px'
        }
      }
    }, passedStyles));

    var handleChange = function handleChange(data) {
      return onChange({
        a: 1,
        h: data.h,
        l: 0.5,
        s: 1
      });
    };

    return _react2.default.createElement('div', {
      style: styles.picker,
      className: 'hue-picker ' + className
    }, _react2.default.createElement(common.Hue, _extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    })));
  };

  HuePicker.propTypes = {
    styles: _propTypes2.default.object
  };
  HuePicker.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: _HuePointer2.default,
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(HuePicker);
});
(0, _chunk76875e.b)(Hue$1);
var Hue_1$1 = Hue$1.HuePicker;
var Material_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Material = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _merge2 = _interopRequireDefault(merge_1);

  var _color2 = _interopRequireDefault(color);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Material = exports.Material = function Material(_ref) {
    var onChange = _ref.onChange,
        hex = _ref.hex,
        rgb = _ref.rgb,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        material: {
          width: '98px',
          height: '98px',
          padding: '16px',
          fontFamily: 'Roboto'
        },
        HEXwrap: {
          position: 'relative'
        },
        HEXinput: {
          width: '100%',
          marginTop: '12px',
          fontSize: '15px',
          color: '#333',
          padding: '0px',
          border: '0px',
          borderBottom: '2px solid ' + hex,
          outline: 'none',
          height: '30px'
        },
        HEXlabel: {
          position: 'absolute',
          top: '0px',
          left: '0px',
          fontSize: '11px',
          color: '#999999',
          textTransform: 'capitalize'
        },
        Hex: {
          style: {}
        },
        RGBwrap: {
          position: 'relative'
        },
        RGBinput: {
          width: '100%',
          marginTop: '12px',
          fontSize: '15px',
          color: '#333',
          padding: '0px',
          border: '0px',
          borderBottom: '1px solid #eee',
          outline: 'none',
          height: '30px'
        },
        RGBlabel: {
          position: 'absolute',
          top: '0px',
          left: '0px',
          fontSize: '11px',
          color: '#999999',
          textTransform: 'capitalize'
        },
        split: {
          display: 'flex',
          marginRight: '-10px',
          paddingTop: '11px'
        },
        third: {
          flex: '1',
          paddingRight: '10px'
        }
      }
    }, passedStyles));

    var handleChange = function handleChange(data, e) {
      if (data.hex) {
        _color2.default.isValidHex(data.hex) && onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        onChange({
          r: data.r || rgb.r,
          g: data.g || rgb.g,
          b: data.b || rgb.b,
          source: 'rgb'
        }, e);
      }
    };

    return _react2.default.createElement(common.Raised, {
      styles: passedStyles
    }, _react2.default.createElement('div', {
      style: styles.material,
      className: 'material-picker ' + className
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.HEXwrap,
        input: styles.HEXinput,
        label: styles.HEXlabel
      },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }), _react2.default.createElement('div', {
      style: styles.split,
      className: 'flexbox-fix'
    }, _react2.default.createElement('div', {
      style: styles.third
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    })), _react2.default.createElement('div', {
      style: styles.third
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    })), _react2.default.createElement('div', {
      style: styles.third
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })))));
  };

  exports.default = (0, common.ColorWrap)(Material);
});
(0, _chunk76875e.b)(Material_1);
var Material_2 = Material_1.Material;
var PhotoshopFields = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PhotoshopPicker = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _color2 = _interopRequireDefault(color);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange,
        rgb = _ref.rgb,
        hsv = _ref.hsv,
        hex = _ref.hex;
    var styles = (0, _reactcss2.default)({
      'default': {
        fields: {
          paddingTop: '5px',
          paddingBottom: '9px',
          width: '80px',
          position: 'relative'
        },
        divider: {
          height: '5px'
        },
        RGBwrap: {
          position: 'relative'
        },
        RGBinput: {
          marginLeft: '40%',
          width: '40%',
          height: '18px',
          border: '1px solid #888888',
          boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
          marginBottom: '5px',
          fontSize: '13px',
          paddingLeft: '3px',
          marginRight: '10px'
        },
        RGBlabel: {
          left: '0px',
          width: '34px',
          textTransform: 'uppercase',
          fontSize: '13px',
          height: '18px',
          lineHeight: '22px',
          position: 'absolute'
        },
        HEXwrap: {
          position: 'relative'
        },
        HEXinput: {
          marginLeft: '20%',
          width: '80%',
          height: '18px',
          border: '1px solid #888888',
          boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
          marginBottom: '6px',
          fontSize: '13px',
          paddingLeft: '3px'
        },
        HEXlabel: {
          position: 'absolute',
          top: '0px',
          left: '0px',
          width: '14px',
          textTransform: 'uppercase',
          fontSize: '13px',
          height: '18px',
          lineHeight: '22px'
        },
        fieldSymbols: {
          position: 'absolute',
          top: '5px',
          right: '-7px',
          fontSize: '13px'
        },
        symbol: {
          height: '20px',
          lineHeight: '22px',
          paddingBottom: '7px'
        }
      }
    });

    var handleChange = function handleChange(data, e) {
      if (data['#']) {
        _color2.default.isValidHex(data['#']) && onChange({
          hex: data['#'],
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        onChange({
          r: data.r || rgb.r,
          g: data.g || rgb.g,
          b: data.b || rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.v) {
        onChange({
          h: data.h || hsv.h,
          s: data.s || hsv.s,
          v: data.v || hsv.v,
          source: 'hsv'
        }, e);
      }
    };

    return _react2.default.createElement('div', {
      style: styles.fields
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }), _react2.default.createElement('div', {
      style: styles.divider
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.RGBwrap,
        input: styles.RGBinput,
        label: styles.RGBlabel
      },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }), _react2.default.createElement('div', {
      style: styles.divider
    }), _react2.default.createElement(common.EditableInput, {
      style: {
        wrap: styles.HEXwrap,
        input: styles.HEXinput,
        label: styles.HEXlabel
      },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }), _react2.default.createElement('div', {
      style: styles.fieldSymbols
    }, _react2.default.createElement('div', {
      style: styles.symbol
    }, '\xB0'), _react2.default.createElement('div', {
      style: styles.symbol
    }, '%'), _react2.default.createElement('div', {
      style: styles.symbol
    }, '%')));
  };

  exports.default = PhotoshopPicker;
});
(0, _chunk76875e.b)(PhotoshopFields);
var PhotoshopFields_1 = PhotoshopFields.PhotoshopPicker;
var PhotoshopPointerCircle_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PhotoshopPointerCircle = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, _reactcss2.default)({
      'default': {
        picker: {
          width: '12px',
          height: '12px',
          borderRadius: '6px',
          boxShadow: 'inset 0 0 0 1px #fff',
          transform: 'translate(-6px, -6px)'
        }
      },
      'black-outline': {
        picker: {
          boxShadow: 'inset 0 0 0 1px #000'
        }
      }
    }, {
      'black-outline': hsl.l > 0.5
    });
    return _react2.default.createElement('div', {
      style: styles.picker
    });
  };

  exports.default = PhotoshopPointerCircle;
});
(0, _chunk76875e.b)(PhotoshopPointerCircle_1);
var PhotoshopPointerCircle_2 = PhotoshopPointerCircle_1.PhotoshopPointerCircle;
var PhotoshopPointer = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PhotoshopPointerCircle = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
    var styles = (0, _reactcss2.default)({
      'default': {
        triangle: {
          width: 0,
          height: 0,
          borderStyle: 'solid',
          borderWidth: '4px 0 4px 6px',
          borderColor: 'transparent transparent transparent #fff',
          position: 'absolute',
          top: '1px',
          left: '1px'
        },
        triangleBorder: {
          width: 0,
          height: 0,
          borderStyle: 'solid',
          borderWidth: '5px 0 5px 8px',
          borderColor: 'transparent transparent transparent #555'
        },
        left: {
          Extend: 'triangleBorder',
          transform: 'translate(-13px, -4px)'
        },
        leftInside: {
          Extend: 'triangle',
          transform: 'translate(-8px, -5px)'
        },
        right: {
          Extend: 'triangleBorder',
          transform: 'translate(20px, -14px) rotate(180deg)'
        },
        rightInside: {
          Extend: 'triangle',
          transform: 'translate(-8px, -5px)'
        }
      }
    });
    return _react2.default.createElement('div', {
      style: styles.pointer
    }, _react2.default.createElement('div', {
      style: styles.left
    }, _react2.default.createElement('div', {
      style: styles.leftInside
    })), _react2.default.createElement('div', {
      style: styles.right
    }, _react2.default.createElement('div', {
      style: styles.rightInside
    })));
  };

  exports.default = PhotoshopPointerCircle;
});
(0, _chunk76875e.b)(PhotoshopPointer);
var PhotoshopPointer_1 = PhotoshopPointer.PhotoshopPointerCircle;
var PhotoshopButton_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PhotoshopButton = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PhotoshopButton = exports.PhotoshopButton = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick,
        label = _ref.label,
        children = _ref.children,
        active = _ref.active;
    var styles = (0, _reactcss2.default)({
      'default': {
        button: {
          backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
          border: '1px solid #878787',
          borderRadius: '2px',
          height: '20px',
          boxShadow: '0 1px 0 0 #EAEAEA',
          fontSize: '14px',
          color: '#000',
          lineHeight: '20px',
          textAlign: 'center',
          marginBottom: '10px',
          cursor: 'pointer'
        }
      },
      'active': {
        button: {
          boxShadow: '0 0 0 1px #878787'
        }
      }
    }, {
      active: active
    });
    return _react2.default.createElement('div', {
      style: styles.button,
      onClick: onClick
    }, label || children);
  };

  exports.default = PhotoshopButton;
});
(0, _chunk76875e.b)(PhotoshopButton_1);
var PhotoshopButton_2 = PhotoshopButton_1.PhotoshopButton;
var PhotoshopPreviews_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.PhotoshopPreviews = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb,
        currentColor = _ref.currentColor;
    var styles = (0, _reactcss2.default)({
      'default': {
        swatches: {
          border: '1px solid #B3B3B3',
          borderBottom: '1px solid #F0F0F0',
          marginBottom: '2px',
          marginTop: '1px'
        },
        new: {
          height: '34px',
          background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
          boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
        },
        current: {
          height: '34px',
          background: currentColor,
          boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
        },
        label: {
          fontSize: '14px',
          color: '#000',
          textAlign: 'center'
        }
      }
    });
    return _react2.default.createElement('div', null, _react2.default.createElement('div', {
      style: styles.label
    }, 'new'), _react2.default.createElement('div', {
      style: styles.swatches
    }, _react2.default.createElement('div', {
      style: styles.new
    }), _react2.default.createElement('div', {
      style: styles.current
    })), _react2.default.createElement('div', {
      style: styles.label
    }, 'current'));
  };

  exports.default = PhotoshopPreviews;
});
(0, _chunk76875e.b)(PhotoshopPreviews_1);
var PhotoshopPreviews_2 = PhotoshopPreviews_1.PhotoshopPreviews;
var Photoshop_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Photoshop = undefined;

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _merge2 = _interopRequireDefault(merge_1);

  var _PhotoshopFields2 = _interopRequireDefault(PhotoshopFields);

  var _PhotoshopPointerCircle2 = _interopRequireDefault(PhotoshopPointerCircle_1);

  var _PhotoshopPointer2 = _interopRequireDefault(PhotoshopPointer);

  var _PhotoshopButton2 = _interopRequireDefault(PhotoshopButton_1);

  var _PhotoshopPreviews2 = _interopRequireDefault(PhotoshopPreviews_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Photoshop = exports.Photoshop = function (_React$Component) {
    _inherits(Photoshop, _React$Component);

    function Photoshop(props) {
      _classCallCheck(this, Photoshop);

      var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

      _this.state = {
        currentColor: props.hex
      };
      return _this;
    }

    _createClass(Photoshop, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            _props$styles = _props.styles,
            passedStyles = _props$styles === undefined ? {} : _props$styles,
            _props$className = _props.className,
            className = _props$className === undefined ? '' : _props$className;
        var styles = (0, _reactcss2.default)((0, _merge2.default)({
          'default': {
            picker: {
              background: '#DCDCDC',
              borderRadius: '4px',
              boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
              boxSizing: 'initial',
              width: '513px'
            },
            head: {
              backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
              borderBottom: '1px solid #B1B1B1',
              boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
              height: '23px',
              lineHeight: '24px',
              borderRadius: '4px 4px 0 0',
              fontSize: '13px',
              color: '#4D4D4D',
              textAlign: 'center'
            },
            body: {
              padding: '15px 15px 0',
              display: 'flex'
            },
            saturation: {
              width: '256px',
              height: '256px',
              position: 'relative',
              border: '2px solid #B3B3B3',
              borderBottom: '2px solid #F0F0F0',
              overflow: 'hidden'
            },
            hue: {
              position: 'relative',
              height: '256px',
              width: '19px',
              marginLeft: '10px',
              border: '2px solid #B3B3B3',
              borderBottom: '2px solid #F0F0F0'
            },
            controls: {
              width: '180px',
              marginLeft: '10px'
            },
            top: {
              display: 'flex'
            },
            previews: {
              width: '60px'
            },
            actions: {
              flex: '1',
              marginLeft: '20px'
            }
          }
        }, passedStyles));
        return _react2.default.createElement('div', {
          style: styles.picker,
          className: 'photoshop-picker ' + className
        }, _react2.default.createElement('div', {
          style: styles.head
        }, this.props.header), _react2.default.createElement('div', {
          style: styles.body,
          className: 'flexbox-fix'
        }, _react2.default.createElement('div', {
          style: styles.saturation
        }, _react2.default.createElement(common.Saturation, {
          hsl: this.props.hsl,
          hsv: this.props.hsv,
          pointer: _PhotoshopPointerCircle2.default,
          onChange: this.props.onChange
        })), _react2.default.createElement('div', {
          style: styles.hue
        }, _react2.default.createElement(common.Hue, {
          direction: 'vertical',
          hsl: this.props.hsl,
          pointer: _PhotoshopPointer2.default,
          onChange: this.props.onChange
        })), _react2.default.createElement('div', {
          style: styles.controls
        }, _react2.default.createElement('div', {
          style: styles.top,
          className: 'flexbox-fix'
        }, _react2.default.createElement('div', {
          style: styles.previews
        }, _react2.default.createElement(_PhotoshopPreviews2.default, {
          rgb: this.props.rgb,
          currentColor: this.state.currentColor
        })), _react2.default.createElement('div', {
          style: styles.actions
        }, _react2.default.createElement(_PhotoshopButton2.default, {
          label: 'OK',
          onClick: this.props.onAccept,
          active: true
        }), _react2.default.createElement(_PhotoshopButton2.default, {
          label: 'Cancel',
          onClick: this.props.onCancel
        }), _react2.default.createElement(_PhotoshopFields2.default, {
          onChange: this.props.onChange,
          rgb: this.props.rgb,
          hsv: this.props.hsv,
          hex: this.props.hex
        }))))));
      }
    }]);

    return Photoshop;
  }(_react2.default.Component);

  Photoshop.propTypes = {
    header: _propTypes2.default.string,
    styles: _propTypes2.default.object
  };
  Photoshop.defaultProps = {
    header: 'Color Picker',
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(Photoshop);
});
(0, _chunk76875e.b)(Photoshop_1);
var Photoshop_2 = Photoshop_1.Photoshop;
var SketchFields_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SketchFields = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _color2 = _interopRequireDefault(color);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SketchFields = exports.SketchFields = function SketchFields(_ref) {
    var onChange = _ref.onChange,
        rgb = _ref.rgb,
        hsl = _ref.hsl,
        hex = _ref.hex,
        disableAlpha = _ref.disableAlpha;
    var styles = (0, _reactcss2.default)({
      'default': {
        fields: {
          display: 'flex',
          paddingTop: '4px'
        },
        single: {
          flex: '1',
          paddingLeft: '6px'
        },
        alpha: {
          flex: '1',
          paddingLeft: '6px'
        },
        double: {
          flex: '2'
        },
        input: {
          width: '80%',
          padding: '4px 10% 3px',
          border: 'none',
          boxShadow: 'inset 0 0 0 1px #ccc',
          fontSize: '11px'
        },
        label: {
          display: 'block',
          textAlign: 'center',
          fontSize: '11px',
          color: '#222',
          paddingTop: '3px',
          paddingBottom: '4px',
          textTransform: 'capitalize'
        }
      },
      'disableAlpha': {
        alpha: {
          display: 'none'
        }
      }
    }, {
      disableAlpha: disableAlpha
    });

    var handleChange = function handleChange(data, e) {
      if (data.hex) {
        _color2.default.isValidHex(data.hex) && onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        onChange({
          r: data.r || rgb.r,
          g: data.g || rgb.g,
          b: data.b || rgb.b,
          a: rgb.a,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 100) {
          data.a = 100;
        }

        data.a /= 100;
        onChange({
          h: hsl.h,
          s: hsl.s,
          l: hsl.l,
          a: data.a,
          source: 'rgb'
        }, e);
      }
    };

    return _react2.default.createElement('div', {
      style: styles.fields,
      className: 'flexbox-fix'
    }, _react2.default.createElement('div', {
      style: styles.double
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        input: styles.input,
        label: styles.label
      },
      label: 'hex',
      value: hex.replace('#', ''),
      onChange: handleChange
    })), _react2.default.createElement('div', {
      style: styles.single
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        input: styles.input,
        label: styles.label
      },
      label: 'r',
      value: rgb.r,
      onChange: handleChange,
      dragLabel: 'true',
      dragMax: '255'
    })), _react2.default.createElement('div', {
      style: styles.single
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        input: styles.input,
        label: styles.label
      },
      label: 'g',
      value: rgb.g,
      onChange: handleChange,
      dragLabel: 'true',
      dragMax: '255'
    })), _react2.default.createElement('div', {
      style: styles.single
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        input: styles.input,
        label: styles.label
      },
      label: 'b',
      value: rgb.b,
      onChange: handleChange,
      dragLabel: 'true',
      dragMax: '255'
    })), _react2.default.createElement('div', {
      style: styles.alpha
    }, _react2.default.createElement(common.EditableInput, {
      style: {
        input: styles.input,
        label: styles.label
      },
      label: 'a',
      value: Math.round(rgb.a * 100),
      onChange: handleChange,
      dragLabel: 'true',
      dragMax: '100'
    })));
  };

  exports.default = SketchFields;
});
(0, _chunk76875e.b)(SketchFields_1);
var SketchFields_2 = SketchFields_1.SketchFields;
var SketchPresetColors_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SketchPresetColors = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
    var colors = _ref.colors,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
        onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcss2.default)({
      'default': {
        colors: {
          margin: '0 -10px',
          padding: '10px 0 0 10px',
          borderTop: '1px solid #eee',
          display: 'flex',
          flexWrap: 'wrap',
          position: 'relative'
        },
        swatchWrap: {
          width: '16px',
          height: '16px',
          margin: '0 10px 10px 0'
        },
        swatch: {
          borderRadius: '3px',
          boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
        }
      },
      'no-presets': {
        colors: {
          display: 'none'
        }
      }
    }, {
      'no-presets': !colors || !colors.length
    });

    var handleClick = function handleClick(hex, e) {
      onClick({
        hex: hex,
        source: 'hex'
      }, e);
    };

    return _react2.default.createElement('div', {
      style: styles.colors,
      className: 'flexbox-fix'
    }, colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? {
        color: colorObjOrString
      } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return _react2.default.createElement('div', {
        key: key,
        style: styles.swatchWrap
      }, _react2.default.createElement(common.Swatch, _extends({}, c, {
        style: styles.swatch,
        onClick: handleClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
        }
      })));
    }));
  };

  SketchPresetColors.propTypes = {
    colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
      color: _propTypes2.default.string,
      title: _propTypes2.default.string
    })])).isRequired
  };
  exports.default = SketchPresetColors;
});
(0, _chunk76875e.b)(SketchPresetColors_1);
var SketchPresetColors_2 = SketchPresetColors_1.SketchPresetColors;
var Sketch_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Sketch = undefined;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _merge2 = _interopRequireDefault(merge_1);

  var _SketchFields2 = _interopRequireDefault(SketchFields_1);

  var _SketchPresetColors2 = _interopRequireDefault(SketchPresetColors_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Sketch = exports.Sketch = function Sketch(_ref) {
    var width = _ref.width,
        rgb = _ref.rgb,
        hex = _ref.hex,
        hsv = _ref.hsv,
        hsl = _ref.hsl,
        onChange = _ref.onChange,
        onSwatchHover = _ref.onSwatchHover,
        disableAlpha = _ref.disableAlpha,
        presetColors = _ref.presetColors,
        renderers = _ref.renderers,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': _extends({
        picker: {
          width: width,
          padding: '10px 10px 0',
          boxSizing: 'initial',
          background: '#fff',
          borderRadius: '4px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
        },
        saturation: {
          width: '100%',
          paddingBottom: '75%',
          position: 'relative',
          overflow: 'hidden'
        },
        Saturation: {
          radius: '3px',
          shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
        },
        controls: {
          display: 'flex'
        },
        sliders: {
          padding: '4px 0',
          flex: '1'
        },
        color: {
          width: '24px',
          height: '24px',
          position: 'relative',
          marginTop: '4px',
          marginLeft: '4px',
          borderRadius: '3px'
        },
        activeColor: {
          absolute: '0px 0px 0px 0px',
          borderRadius: '2px',
          background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
          boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
        },
        hue: {
          position: 'relative',
          height: '10px',
          overflow: 'hidden'
        },
        Hue: {
          radius: '2px',
          shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
        },
        alpha: {
          position: 'relative',
          height: '10px',
          marginTop: '4px',
          overflow: 'hidden'
        },
        Alpha: {
          radius: '2px',
          shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
        }
      }, passedStyles),
      'disableAlpha': {
        color: {
          height: '10px'
        },
        hue: {
          height: '10px'
        },
        alpha: {
          display: 'none'
        }
      }
    }, passedStyles), {
      disableAlpha: disableAlpha
    });
    return _react2.default.createElement('div', {
      style: styles.picker,
      className: 'sketch-picker ' + className
    }, _react2.default.createElement('div', {
      style: styles.saturation
    }, _react2.default.createElement(common.Saturation, {
      style: styles.Saturation,
      hsl: hsl,
      hsv: hsv,
      onChange: onChange
    })), _react2.default.createElement('div', {
      style: styles.controls,
      className: 'flexbox-fix'
    }, _react2.default.createElement('div', {
      style: styles.sliders
    }, _react2.default.createElement('div', {
      style: styles.hue
    }, _react2.default.createElement(common.Hue, {
      style: styles.Hue,
      hsl: hsl,
      onChange: onChange
    })), _react2.default.createElement('div', {
      style: styles.alpha
    }, _react2.default.createElement(common.Alpha, {
      style: styles.Alpha,
      rgb: rgb,
      hsl: hsl,
      renderers: renderers,
      onChange: onChange
    }))), _react2.default.createElement('div', {
      style: styles.color
    }, _react2.default.createElement(common.Checkboard, null), _react2.default.createElement('div', {
      style: styles.activeColor
    }))), _react2.default.createElement(_SketchFields2.default, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }), _react2.default.createElement(_SketchPresetColors2.default, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    }));
  };

  Sketch.propTypes = {
    disableAlpha: _propTypes2.default.bool,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    styles: _propTypes2.default.object
  };
  Sketch.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
  };
  exports.default = (0, common.ColorWrap)(Sketch);
});
(0, _chunk76875e.b)(Sketch_1);
var Sketch_2 = Sketch_1.Sketch;
var SliderSwatch_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SliderSwatch = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
    var hsl = _ref.hsl,
        offset = _ref.offset,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
        active = _ref.active,
        first = _ref.first,
        last = _ref.last;
    var styles = (0, _reactcss2.default)({
      'default': {
        swatch: {
          height: '12px',
          background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
          cursor: 'pointer'
        }
      },
      'first': {
        swatch: {
          borderRadius: '2px 0 0 2px'
        }
      },
      'last': {
        swatch: {
          borderRadius: '0 2px 2px 0'
        }
      },
      'active': {
        swatch: {
          transform: 'scaleY(1.8)',
          borderRadius: '3.6px/2px'
        }
      }
    }, {
      active: active,
      first: first,
      last: last
    });

    var handleClick = function handleClick(e) {
      return onClick({
        h: hsl.h,
        s: 0.5,
        l: offset,
        source: 'hsl'
      }, e);
    };

    return _react2.default.createElement('div', {
      style: styles.swatch,
      onClick: handleClick
    });
  };

  exports.default = SliderSwatch;
});
(0, _chunk76875e.b)(SliderSwatch_1);
var SliderSwatch_2 = SliderSwatch_1.SliderSwatch;
var SliderSwatches_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SliderSwatches = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _SliderSwatch2 = _interopRequireDefault(SliderSwatch_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
    var onClick = _ref.onClick,
        hsl = _ref.hsl;
    var styles = (0, _reactcss2.default)({
      'default': {
        swatches: {
          marginTop: '20px'
        },
        swatch: {
          boxSizing: 'border-box',
          width: '20%',
          paddingRight: '1px',
          float: 'left'
        },
        clear: {
          clear: 'both'
        }
      }
    });
    var epsilon = 0.1;
    return _react2.default.createElement('div', {
      style: styles.swatches
    }, _react2.default.createElement('div', {
      style: styles.swatch
    }, _react2.default.createElement(_SliderSwatch2.default, {
      hsl: hsl,
      offset: '.80',
      active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
      onClick: onClick,
      first: true
    })), _react2.default.createElement('div', {
      style: styles.swatch
    }, _react2.default.createElement(_SliderSwatch2.default, {
      hsl: hsl,
      offset: '.65',
      active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
      onClick: onClick
    })), _react2.default.createElement('div', {
      style: styles.swatch
    }, _react2.default.createElement(_SliderSwatch2.default, {
      hsl: hsl,
      offset: '.50',
      active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
      onClick: onClick
    })), _react2.default.createElement('div', {
      style: styles.swatch
    }, _react2.default.createElement(_SliderSwatch2.default, {
      hsl: hsl,
      offset: '.35',
      active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
      onClick: onClick
    })), _react2.default.createElement('div', {
      style: styles.swatch
    }, _react2.default.createElement(_SliderSwatch2.default, {
      hsl: hsl,
      offset: '.20',
      active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
      onClick: onClick,
      last: true
    })), _react2.default.createElement('div', {
      style: styles.clear
    }));
  };

  exports.default = SliderSwatches;
});
(0, _chunk76875e.b)(SliderSwatches_1);
var SliderSwatches_2 = SliderSwatches_1.SliderSwatches;
var SliderPointer_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SliderPointer = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SliderPointer = exports.SliderPointer = function SliderPointer() {
    var styles = (0, _reactcss2.default)({
      'default': {
        picker: {
          width: '14px',
          height: '14px',
          borderRadius: '6px',
          transform: 'translate(-7px, -1px)',
          backgroundColor: 'rgb(248, 248, 248)',
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
        }
      }
    });
    return _react2.default.createElement('div', {
      style: styles.picker
    });
  };

  exports.default = SliderPointer;
});
(0, _chunk76875e.b)(SliderPointer_1);
var SliderPointer_2 = SliderPointer_1.SliderPointer;
var Slider_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Slider = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _merge2 = _interopRequireDefault(merge_1);

  var _SliderSwatches2 = _interopRequireDefault(SliderSwatches_1);

  var _SliderPointer2 = _interopRequireDefault(SliderPointer_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Slider = exports.Slider = function Slider(_ref) {
    var hsl = _ref.hsl,
        onChange = _ref.onChange,
        pointer = _ref.pointer,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        hue: {
          height: '12px',
          position: 'relative'
        },
        Hue: {
          radius: '2px'
        }
      }
    }, passedStyles));
    return _react2.default.createElement('div', {
      style: styles.wrap || {},
      className: 'slider-picker ' + className
    }, _react2.default.createElement('div', {
      style: styles.hue
    }, _react2.default.createElement(common.Hue, {
      style: styles.Hue,
      hsl: hsl,
      pointer: pointer,
      onChange: onChange
    })), _react2.default.createElement('div', {
      style: styles.swatches
    }, _react2.default.createElement(_SliderSwatches2.default, {
      hsl: hsl,
      onClick: onChange
    })));
  };

  Slider.propTypes = {
    styles: _propTypes2.default.object
  };
  Slider.defaultProps = {
    pointer: _SliderPointer2.default,
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(Slider);
});
(0, _chunk76875e.b)(Slider_1);
var Slider_2 = Slider_1.Slider;
var CheckIcon = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _objectWithoutProperties$$1(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  var DEFAULT_SIZE = 24;

  exports.default = function (_ref) {
    var _ref$fill = _ref.fill,
        fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        props = _objectWithoutProperties$$1(_ref, ['fill', 'width', 'height', 'style']);

    return _react2.default.createElement('svg', _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({
        fill: fill,
        width: width,
        height: height
      }, style)
    }, props), _react2.default.createElement('path', {
      d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
    }));
  };
});
(0, _chunk76875e.b)(CheckIcon);
var SwatchesColor_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SwatchesColor = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _color2 = _interopRequireDefault(color);

  var _CheckIcon2 = _interopRequireDefault(CheckIcon);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
    var color$$1 = _ref.color,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
        onSwatchHover = _ref.onSwatchHover,
        first = _ref.first,
        last = _ref.last,
        active = _ref.active;
    var styles = (0, _reactcss2.default)({
      'default': {
        color: {
          width: '40px',
          height: '24px',
          cursor: 'pointer',
          background: color$$1,
          marginBottom: '1px'
        },
        check: {
          color: _color2.default.getContrastingColor(color$$1),
          marginLeft: '8px',
          display: 'none'
        }
      },
      'first': {
        color: {
          overflow: 'hidden',
          borderRadius: '2px 2px 0 0'
        }
      },
      'last': {
        color: {
          overflow: 'hidden',
          borderRadius: '0 0 2px 2px'
        }
      },
      'active': {
        check: {
          display: 'block'
        }
      },
      'color-#FFFFFF': {
        color: {
          boxShadow: 'inset 0 0 0 1px #ddd'
        },
        check: {
          color: '#333'
        }
      },
      'transparent': {
        check: {
          color: '#333'
        }
      }
    }, {
      first: first,
      last: last,
      active: active,
      'color-#FFFFFF': color$$1 === '#FFFFFF',
      'transparent': color$$1 === 'transparent'
    });
    return _react2.default.createElement(common.Swatch, {
      color: color$$1,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: {
        boxShadow: '0 0 4px ' + color$$1
      }
    }, _react2.default.createElement('div', {
      style: styles.check
    }, _react2.default.createElement(_CheckIcon2.default, null)));
  };

  exports.default = SwatchesColor;
});
(0, _chunk76875e.b)(SwatchesColor_1);
var SwatchesColor_2 = SwatchesColor_1.SwatchesColor;
var SwatchesGroup_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.SwatchesGroup = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _map2 = _interopRequireDefault(_ColorPickerInput5631f.C);

  var _SwatchesColor2 = _interopRequireDefault(SwatchesColor_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick,
        onSwatchHover = _ref.onSwatchHover,
        group = _ref.group,
        active = _ref.active;
    var styles = (0, _reactcss2.default)({
      'default': {
        group: {
          paddingBottom: '10px',
          width: '40px',
          float: 'left',
          marginRight: '10px'
        }
      }
    });
    return _react2.default.createElement('div', {
      style: styles.group
    }, (0, _map2.default)(group, function (color, i) {
      return _react2.default.createElement(_SwatchesColor2.default, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    }));
  };

  exports.default = SwatchesGroup;
});
(0, _chunk76875e.b)(SwatchesGroup_1);
var SwatchesGroup_2 = SwatchesGroup_1.SwatchesGroup;
var Swatches_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Swatches = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _map2 = _interopRequireDefault(_ColorPickerInput5631f.C);

  var _merge2 = _interopRequireDefault(merge_1);

  var _color2 = _interopRequireDefault(color);

  var material = _interopRequireWildcard(_materialColors);

  var _SwatchesGroup2 = _interopRequireDefault(SwatchesGroup_1);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Swatches = exports.Swatches = function Swatches(_ref) {
    var width = _ref.width,
        height = _ref.height,
        onChange = _ref.onChange,
        onSwatchHover = _ref.onSwatchHover,
        colors = _ref.colors,
        hex = _ref.hex,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        picker: {
          width: width,
          height: height
        },
        overflow: {
          height: height,
          overflowY: 'scroll'
        },
        body: {
          padding: '16px 0 6px 16px'
        },
        clear: {
          clear: 'both'
        }
      }
    }, passedStyles));

    var handleChange = function handleChange(data, e) {
      _color2.default.isValidHex(data) && onChange({
        hex: data,
        source: 'hex'
      }, e);
    };

    return _react2.default.createElement('div', {
      style: styles.picker,
      className: 'swatches-picker ' + className
    }, _react2.default.createElement(common.Raised, null, _react2.default.createElement('div', {
      style: styles.overflow
    }, _react2.default.createElement('div', {
      style: styles.body
    }, (0, _map2.default)(colors, function (group) {
      return _react2.default.createElement(_SwatchesGroup2.default, {
        key: group.toString(),
        group: group,
        active: hex,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    }), _react2.default.createElement('div', {
      style: styles.clear
    })))));
  };

  Swatches.propTypes = {
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)),
    styles: _propTypes2.default.object
  };
  Swatches.defaultProps = {
    width: 320,
    height: 240,
    colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(Swatches);
});
(0, _chunk76875e.b)(Swatches_1);
var Swatches_2 = Swatches_1.Swatches;
var Twitter_1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Twitter = undefined;

  var _react2 = _interopRequireDefault(_chunk8219403d.a);

  var _propTypes2 = _interopRequireDefault(_chunkEb19ede.a);

  var _reactcss2 = _interopRequireDefault(_ColorPickerInput5631f.a);

  var _map2 = _interopRequireDefault(_ColorPickerInput5631f.C);

  var _merge2 = _interopRequireDefault(merge_1);

  var _color2 = _interopRequireDefault(color);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var Twitter = exports.Twitter = function Twitter(_ref) {
    var onChange = _ref.onChange,
        onSwatchHover = _ref.onSwatchHover,
        hex = _ref.hex,
        colors = _ref.colors,
        width = _ref.width,
        triangle = _ref.triangle,
        _ref$styles = _ref.styles,
        passedStyles = _ref$styles === undefined ? {} : _ref$styles,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcss2.default)((0, _merge2.default)({
      'default': {
        card: {
          width: width,
          background: '#fff',
          border: '0 solid rgba(0,0,0,0.25)',
          boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
          borderRadius: '4px',
          position: 'relative'
        },
        body: {
          padding: '15px 9px 9px 15px'
        },
        label: {
          fontSize: '18px',
          color: '#fff'
        },
        triangle: {
          width: '0px',
          height: '0px',
          borderStyle: 'solid',
          borderWidth: '0 9px 10px 9px',
          borderColor: 'transparent transparent #fff transparent',
          position: 'absolute'
        },
        triangleShadow: {
          width: '0px',
          height: '0px',
          borderStyle: 'solid',
          borderWidth: '0 9px 10px 9px',
          borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
          position: 'absolute'
        },
        hash: {
          background: '#F0F0F0',
          height: '30px',
          width: '30px',
          borderRadius: '4px 0 0 4px',
          float: 'left',
          color: '#98A1A4',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        input: {
          width: '100px',
          fontSize: '14px',
          color: '#666',
          border: '0px',
          outline: 'none',
          height: '28px',
          boxShadow: 'inset 0 0 0 1px #F0F0F0',
          boxSizing: 'content-box',
          borderRadius: '0 4px 4px 0',
          float: 'left',
          paddingLeft: '8px'
        },
        swatch: {
          width: '30px',
          height: '30px',
          float: 'left',
          borderRadius: '4px',
          margin: '0 6px 6px 0'
        },
        clear: {
          clear: 'both'
        }
      },
      'hide-triangle': {
        triangle: {
          display: 'none'
        },
        triangleShadow: {
          display: 'none'
        }
      },
      'top-left-triangle': {
        triangle: {
          top: '-10px',
          left: '12px'
        },
        triangleShadow: {
          top: '-11px',
          left: '12px'
        }
      },
      'top-right-triangle': {
        triangle: {
          top: '-10px',
          right: '12px'
        },
        triangleShadow: {
          top: '-11px',
          right: '12px'
        }
      }
    }, passedStyles), {
      'hide-triangle': triangle === 'hide',
      'top-left-triangle': triangle === 'top-left',
      'top-right-triangle': triangle === 'top-right'
    });

    var handleChange = function handleChange(hexcode, e) {
      _color2.default.isValidHex(hexcode) && onChange({
        hex: hexcode,
        source: 'hex'
      }, e);
    };

    return _react2.default.createElement('div', {
      style: styles.card,
      className: 'twitter-picker ' + className
    }, _react2.default.createElement('div', {
      style: styles.triangleShadow
    }), _react2.default.createElement('div', {
      style: styles.triangle
    }), _react2.default.createElement('div', {
      style: styles.body
    }, (0, _map2.default)(colors, function (c, i) {
      return _react2.default.createElement(common.Swatch, {
        key: i,
        color: c,
        hex: c,
        style: styles.swatch,
        onClick: handleChange,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }), _react2.default.createElement('div', {
      style: styles.hash
    }, '#'), _react2.default.createElement(common.EditableInput, {
      label: null,
      style: {
        input: styles.input
      },
      value: hex.replace('#', ''),
      onChange: handleChange
    }), _react2.default.createElement('div', {
      style: styles.clear
    })));
  };

  Twitter.propTypes = {
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
    colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
    styles: _propTypes2.default.object
  };
  Twitter.defaultProps = {
    width: 276,
    colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
    triangle: 'top-left',
    styles: {}
  };
  exports.default = (0, common.ColorWrap)(Twitter);
});
(0, _chunk76875e.b)(Twitter_1);
var Twitter_2 = Twitter_1.Twitter;
var lib$1 = (0, _chunk76875e.c)(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;
  Object.defineProperty(exports, 'AlphaPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Alpha$1).default;
    }
  });
  Object.defineProperty(exports, 'BlockPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Block_1).default;
    }
  });
  Object.defineProperty(exports, 'CirclePicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Circle_1).default;
    }
  });
  Object.defineProperty(exports, 'ChromePicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Chrome_1).default;
    }
  });
  Object.defineProperty(exports, 'CompactPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Compact_1).default;
    }
  });
  Object.defineProperty(exports, 'GithubPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Github_1).default;
    }
  });
  Object.defineProperty(exports, 'HuePicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Hue$1).default;
    }
  });
  Object.defineProperty(exports, 'MaterialPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Material_1).default;
    }
  });
  Object.defineProperty(exports, 'PhotoshopPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Photoshop_1).default;
    }
  });
  Object.defineProperty(exports, 'SketchPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Sketch_1).default;
    }
  });
  Object.defineProperty(exports, 'SliderPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Slider_1).default;
    }
  });
  Object.defineProperty(exports, 'SwatchesPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Swatches_1).default;
    }
  });
  Object.defineProperty(exports, 'TwitterPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(Twitter_1).default;
    }
  });
  Object.defineProperty(exports, 'CustomPicker', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(ColorWrap_1).default;
    }
  });

  var _Chrome2 = _interopRequireDefault(Chrome_1);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _Chrome2.default;
});
(0, _chunk76875e.b)(lib$1);
var lib_1 = lib$1.CustomPicker;
var lib_2 = lib$1.TwitterPicker;
var lib_3 = lib$1.SwatchesPicker;
var lib_4 = lib$1.SliderPicker;
var lib_5 = lib$1.SketchPicker;
var lib_6 = lib$1.PhotoshopPicker;
var lib_7 = lib$1.MaterialPicker;
var lib_8 = lib$1.HuePicker;
var lib_9 = lib$1.GithubPicker;
var lib_10 = lib$1.CompactPicker;
var lib_11 = lib$1.ChromePicker;
var lib_12 = lib$1.CirclePicker;
var lib_13 = lib$1.BlockPicker;
var lib_14 = lib$1.AlphaPicker;

function _templateObject9() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: block;\n  position: relative;\n  background: rgb(255, 255, 255) none repeat scroll 0% 0%;\n  border-radius: ", ";\n  box-shadow: ", ";\n  box-sizing: initial;\n  width: 240px;\n  height: auto;\n  z-index: 1000;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  display: block;\n  height: 10px;\n  margin-top: 10px;\n  > div > div {\n    border-radius: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  display: block;\n  height: 10px;\n  .hue-horizontal {\n    border-radius: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  width: 100%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  display: block;\n  height: 20px;\n  margin-top: 20px;\n  margin-bottom: 30px;\n  display: inline-flex;\n  align-items: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _chunkB2edacfb.a)(["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 150px;\n  div {\n    border-top-right-radius: ", ";\n    border-top-left-radius: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: block;\n  margin-right: 10px;\n  min-width: 20px;\n  height: 20px;\n  width: 20px;\n  border-radius: 20px;\n  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n  width: 10px;\n  height: 10px;\n  border-radius: 10px;\n  background-color: transparent;\n  border: 2px solid white;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  padding: 20px 20px 5px 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _require = require("react-color/lib/components/common"),
    Alpha$3 = _require.Alpha,
    Hue$3 = _require.Hue,
    Saturation$1 = _require.Saturation;

var CColorPicker = function CColorPicker(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      swatches = _ref.swatches,
      onChange = _ref.onChange,
      alphaValues = _ref.alphaValues,
      color = _ref.color,
      rest = (0, _chunkB2edacfb.j)(_ref, ["hex", "rgb", "hsl", "hsv", "swatches", "onChange", "alphaValues", "color"]);
  return _react3.default.createElement(ColorPickerWrapper, rest, _react3.default.createElement(SatWrapper, null, _react3.default.createElement(Saturation$1, {
    className: "saturation",
    hsl: hsl,
    hsv: hsv,
    onChange: onChange,
    pointer: Pointer
  })), _react3.default.createElement(Content, null, _react3.default.createElement(_chunkB15f.b, {
    alignItems: "center"
  }, _react3.default.createElement(ColorCircle, {
    style: {
      backgroundColor: hex
    }
  }), _react3.default.createElement(_chunkB15f.a, {
    width: "100%",
    height: "100%"
  }, _react3.default.createElement(HueWrapper, null, _react3.default.createElement(Hue$3, {
    hsl: hsl,
    onChange: onChange,
    pointer: Pointer
  })), alphaValues && _react3.default.createElement(AlphaWrapper, null, _react3.default.createElement(Alpha$3, {
    rgb: rgb,
    hsl: hsl,
    onChange: onChange,
    pointer: Pointer
  })))), _react3.default.createElement(FieldsWrapper, null, _react3.default.createElement(_ColorPickerFields.default, {
    alphaValues: alphaValues,
    rgb: rgb,
    hsl: hsl,
    hex: hex,
    onChange: onChange
  })), swatches && _react3.default.createElement(SwatchWrapper, null, _react3.default.createElement(_ColorPickerSwatches.default, {
    rgb: rgb,
    hsl: hsl,
    hex: hex,
    onChange: onChange,
    swatches: swatches
  }))));
};

exports.CColorPicker = CColorPicker;
CColorPicker.defaultProps = {
  alphaValues: false
};
var RADIUS = "8px";

var Content = _styledComponents.default.div.withConfig({
  displayName: "CColorPicker__Content",
  componentId: "sc-19ihert-0"
})(_templateObject());

var Pointer = _styledComponents.default.div.withConfig({
  displayName: "CColorPicker__Pointer",
  componentId: "sc-19ihert-1"
})(_templateObject2());

var ColorCircle = _styledComponents.default.div.withConfig({
  displayName: "CColorPicker__ColorCircle",
  componentId: "sc-19ihert-2"
})(_templateObject3());

var SatWrapper = _styledComponents.default.section.withConfig({
  displayName: "CColorPicker__SatWrapper",
  componentId: "sc-19ihert-3"
})(_templateObject4(), RADIUS, RADIUS);

var FieldsWrapper = _styledComponents.default.section.withConfig({
  displayName: "CColorPicker__FieldsWrapper",
  componentId: "sc-19ihert-4"
})(_templateObject5());

var SwatchWrapper = _styledComponents.default.section.withConfig({
  displayName: "CColorPicker__SwatchWrapper",
  componentId: "sc-19ihert-5"
})(_templateObject6());

var HueWrapper = _styledComponents.default.section.withConfig({
  displayName: "CColorPicker__HueWrapper",
  componentId: "sc-19ihert-6"
})(_templateObject7(), RADIUS);

var AlphaWrapper = _styledComponents.default.section.withConfig({
  displayName: "CColorPicker__AlphaWrapper",
  componentId: "sc-19ihert-7"
})(_templateObject8(), RADIUS);

var ColorPickerWrapper = (0, _styledComponents.default)(_chunkB15f.a).withConfig({
  displayName: "CColorPicker__ColorPickerWrapper",
  componentId: "sc-19ihert-8"
})(_templateObject9(), RADIUS, function (props) {
  return props.theme["$box-shadow-2"];
});
var CColorPicker$1 = lib_1(CColorPicker);
CColorPicker.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CColorPicker",
  "props": {
    "alphaValues": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};
var _default = CColorPicker$1;
exports.default = _default;
CColorPicker.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CColorPicker",
  "props": {
    "alphaValues": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false
    }
  }
};